
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5CNGn", function(module, exports) {

var $1ydBT = parcelRequire("1ydBT");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $l1uFv = parcelRequire("l1uFv");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $aqBZ0 = parcelRequire("aqBZ0");


var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});


/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");







// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $buxP3.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};



var $8SCD6 = parcelRequire("8SCD6");


var $fNzRA = parcelRequire("fNzRA");

/**
 * @generated SignedSource<<9f5ea8b9eb83cb4328a18f4f1d80c7cb>>
 * @relayHash 765a0e8684153a74a9625d61eb5a36c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd7425461154d822e729902b362c9b0dcb31cef6f2130a55b0aa812185fa407c
const $29a5cbc606375ce1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    }
                ]
            }
        ],
        "type": "FooterComment"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "765a0e8684153a74a9625d61eb5a36c9",
            "id": "bd7425461154d822e729902b362c9b0dcb31cef6f2130a55b0aa812185fa407c",
            "metadata": {},
            "name": "ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,parentId,author{__typename,displayName,...on KnownUser{accountId}},location{__typename,type,...on FooterComment{commentResolveProperties{resolved}}}}}}"
        }
    };
}();
$29a5cbc606375ce1$var$node.hash = "414c0e80c6879acd5ff83647527d3be3";
var $29a5cbc606375ce1$export$2e2bcd8739ae039 = $29a5cbc606375ce1$var$node;






var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");








var $aSsfA = parcelRequire("aSsfA");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $eTcMK = parcelRequire("eTcMK");


var $jMyy4 = parcelRequire("jMyy4");


var $ifBRq = parcelRequire("ifBRq");

const $90365d58d6587547$var$ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery = (0, $29a5cbc606375ce1$export$2e2bcd8739ae039);
const $90365d58d6587547$var$logger = (0, $7W8i8.getLogger)('inline-comments:query-param-listener');
const $90365d58d6587547$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $90365d58d6587547$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
// Maximum wait time for scroll operations (in milliseconds)
const $90365d58d6587547$var$SCROLL_TIMEOUT_MS = 4000;
// Minimum time page must be stable before scrolling (in milliseconds)
const $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS = 500;
// Wait for document height to stabilize (tables may have async layout)
const $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS = 150;
// If there is a link to non-existent (probably deleted) comment, we don't want to show an error
const $90365d58d6587547$var$expectedErrorCodes = [
    404
];
const $90365d58d6587547$var$isExpectedError = (error)=>error.graphQLErrors.some((e)=>$90365d58d6587547$var$expectedErrorCodes.includes(e?.extensions?.statusCode));
const $90365d58d6587547$var$ObjectCommentQueryParamsListenerComponent = ({ hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    // Helper function to clear scroll timeout/callback
    const clearScrollTimeout = ()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') // requestIdleCallback ID
            {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(scrollTimeoutRef.current);
            } else // setTimeout ID
            clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    };
    // Helper function to clean up MutationObserver
    const cleanupMutationObserver = ()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    };
    // Helper function to clean up both observer and timeout (only if they were set up)
    const cleanupScrollResources = (0, $cozmU.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, []); // Empty deps: only uses refs which don't change
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const focusedCommentId = $90365d58d6587547$var$useFocusedCommentIdQueryParam();
    const replyToComment = $90365d58d6587547$var$useReplyToCommentQueryParam();
    const commentId = focusedCommentId || replyToComment;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($90365d58d6587547$var$ObjectCommentQueryParamsListenerObjectCommentQueryParamsQuery, {
        variables: {
            commentId: commentId
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "comments-query-param-handlers"
    });
    if (error && !$90365d58d6587547$var$isExpectedError(error)) $90365d58d6587547$var$logger.error`An error occurred when querying the focused object comment status; ${error}`;
    let isResolved = undefined;
    let parentId = undefined;
    // Extract resolved status and parentId from either new or old flow
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Extract from useCommentById
    {
        if (comment && !commentError) {
            const location = comment.location;
            isResolved = Boolean(location?.commentResolveProperties?.resolved);
            parentId = comment.parentId;
        }
    } else // OLD FLOW: Extract from GraphQL query
    // If the commentId is not present, error is defined and isResolved will be undefined
    if (data && !error) {
        const location_0 = data?.comments?.nodes?.[0]?.location;
        isResolved = Boolean(location_0?.commentResolveProperties?.resolved);
        parentId = data?.comments?.nodes?.[0]?.parentId;
    }
    // Get comment data for replyToComment handling (with author)
    const rawCommentForReply = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment : data?.comments?.nodes?.[0] || null;
    // Handle scrolling to focused comment or replyToComment after the data is loaded
    (0, $cozmU.useEffect)(()=>{
        // Determine if we have data from new or old flow
        const hasData = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment && !commentError : data && !error;
        // Update currentlySelectedThreadKey to root comment ID when data becomes available
        // This runs even after scroll has happened to ensure correct thread highlighting
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) {
                    const rootComment = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId);
                    rootCommentId = rootComment?.id;
                }
            } else {
                const legacyFooterComments = Object.values(commentsDataMap.general);
                if (legacyFooterComments.length > 0) {
                    const rootComment_0 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments, parentId);
                    rootCommentId = rootComment_0?.id;
                }
            }
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if comment type is INLINE - this component only handles footer/object comments
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const location_1 = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location : data?.comments?.nodes?.[0]?.location;
            if (location_1 && 'type' in location_1 && location_1.type === 'INLINE') return;
        }
        if (// Note that if the commentId is not found, the query will return an error and we don't
        // have to scroll to the comment
        commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $8i27m.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                const commentElement = document.getElementById(commentElementId);
                const replyCommentElement = document.getElementById(replyCommentElementId);
                const element = commentElement || replyCommentElement;
                // When experiment is enabled, select the root thread (for replies) or the comment itself
                // This ensures the entire thread is highlighted when deep-linking to a reply
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    // Try to find the root comment ID from available data sources
                    let rootCommentId_0;
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) {
                            const rootComment_1 = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId);
                            rootCommentId_0 = rootComment_1?.id;
                        }
                    } else {
                        const legacyFooterComments_0 = Object.values(commentsDataMap.general);
                        if (legacyFooterComments_0.length > 0) {
                            const rootComment_2 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments_0, parentId);
                            rootCommentId_0 = rootComment_2?.id;
                        }
                    }
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                // Use unified navigation for scrolling
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            // Get author information from comment data
                            const commentWithAuthor = rawCommentForReply;
                            const author = commentWithAuthor?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        // Use MutationObserver to watch for when the element is ready
                        // Clean up any existing observer first
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const element_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (element_0 && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                element_0.offsetTop;
                                getDocumentScrollHeight();
                            }
                            (0, $9FoVw.handleFooterCommentsNavigation)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        // Perform scroll; when FG on: double rAF + force reflow for correct layout
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>{
                                requestAnimationFrame(scrollToComment);
                            });
                            else scrollToComment();
                        };
                        // When FG on: check document height stable (tables may have async layout)
                        const checkHeightStabilityThenScroll = ()=>{
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        // Schedule scroll when page is idle/stable
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            // Track when we detected the element is ready
                            lastMutationTimeRef.current = Date.now();
                            // Use requestIdleCallback if available, otherwise fallback to setTimeout
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSinceLastMutation = Date.now() - lastMutationTimeRef.current;
                                    if (timeSinceLastMutation >= $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS) // Mutations stable - when FG on: check height stable, then scroll
                                    checkHeightStabilityThenScroll();
                                    else // Not stable yet - wait and re-check (don't scroll blindly)
                                    scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS - timeSinceLastMutation);
                                };
                                checkStabilityAndScroll();
                            });
                            else // Fallback for browsers without requestIdleCallback (e.g., Safari)
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                        };
                        // Check if element exists and is ready (has content and is visible)
                        const getElementAndCheckReady = ()=>{
                            const foundElement = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!foundElement) return {
                                element: null,
                                isReady: false
                            };
                            const rect = foundElement.getBoundingClientRect();
                            const elementIsReady = foundElement.offsetHeight > 0 && foundElement.offsetWidth > 0 && rect.height > 0 && rect.width > 0;
                            return {
                                element: foundElement,
                                isReady: elementIsReady
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        // If element exists and is already ready, schedule scroll with delay
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            // Set up MutationObserver to watch for when element appears or becomes ready
                            mutationObserverRef.current = new MutationObserver(()=>{
                                // Update last mutation time when DOM changes
                                lastMutationTimeRef.current = Date.now();
                                const { element: foundElement_0, isReady: foundIsReady } = getElementAndCheckReady();
                                if (foundElement_0 && foundIsReady) scheduleScroll();
                            });
                            // If element exists, observe it and its parent
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parentContainer = currentElement.parentElement;
                                if (parentContainer) mutationObserverRef.current.observe(parentContainer, {
                                    childList: true,
                                    subtree: true
                                });
                            } else // If element doesn't exist yet, observe document.body to detect when it appears
                            mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            // Fallback timeout in case MutationObserver doesn't detect changes
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                        }
                    } else // Experiment disabled - scroll immediately if element exists
                    if (element) {
                        (0, $9FoVw.handleFooterCommentsNavigation)({
                            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                            block: 'center',
                            inline: 'center',
                            commentId: commentId,
                            navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                        });
                        setHasScrolledToFocusedComment(true);
                        setCurrentlySelectedThreadKey(threadToBeSelected);
                    }
                }
            }
        }
    }, [
        data,
        error,
        comment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        rawCommentForReply,
        parentId,
        processedCommentsData,
        commentsDataMap
    ]);
    // Reset scroll tracking when focusedCommentId or replyToComment changes
    (0, $cozmU.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        // Clean up scroll resources when comment ID changes (only if they were set up)
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    // Clean up MutationObserver and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanupScrollResources();
        };
    }, [
        cleanupScrollResources
    ]);
    // Force load comments if focusedCommentId or replayToComment is present
    (0, $cozmU.useEffect)(()=>{
        if ((focusedCommentId || replyToComment) && !hasLoadedObjectComments) setForceLoadComments(true);
    }, [
        focusedCommentId,
        replyToComment,
        hasLoadedObjectComments,
        setForceLoadComments
    ]);
    return null;
};
const $90365d58d6587547$var$withObjectCommentQueryParamUnification = (Component)=>(props)=>{
        if ((0, $9wGTI.fg)('confluence_comment_param_unification')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifBRq.CommentQueryParamsListener), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
    };
const $90365d58d6587547$export$1e65952d87b47593 = $90365d58d6587547$var$withObjectCommentQueryParamUnification($90365d58d6587547$var$ObjectCommentQueryParamsListenerComponent);



var $dkkKv = parcelRequire("dkkKv");








var $6lAIr = parcelRequire("6lAIr");





var $aHcFH = parcelRequire("aHcFH");


var $lFkRf = parcelRequire("lFkRf");


var $FBfum = parcelRequire("FBfum");


var $isEtk = parcelRequire("isEtk");


var $5vi32 = parcelRequire("5vi32");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");








var $7aRa9 = parcelRequire("7aRa9");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $irVI7 = parcelRequire("irVI7");


var $b0EGa = parcelRequire("b0EGa");





var $htsj6 = parcelRequire("htsj6");


var $cD1qu = parcelRequire("cD1qu");





var $jAfH5 = parcelRequire("jAfH5");





var $e4o8D = parcelRequire("e4o8D");


var $fHAwL = parcelRequire("fHAwL");








var $eCryJ = parcelRequire("eCryJ");


var $5kqgA = parcelRequire("5kqgA");


var $bQm3c = parcelRequire("bQm3c");


var $6FXhW = parcelRequire("6FXhW");


var $cvIm8 = parcelRequire("cvIm8");

// Delay before deleting the per-user `cc-agent-mention-sessions` marker when the sessions query
// is empty. Derived from the sessions-poll schedule so it always outlasts the final poll (+2s
// margin): a freshly-mentioned comment's session is created asynchronously by the backend, so the
// query is briefly empty while usePageCommentAgentSessionsInner polls. Deriving it from
// SESSION_REFETCH_DELAYS_MS (rather than hardcoding) keeps the two in lockstep if the poll
// schedule ever changes.
const $ac96fb5095c0413f$var$MARKER_DELETE_DELAY_MS = Math.max(...(0, $cvIm8.SESSION_REFETCH_DELAYS_MS)) + 2000;
/**
 * Inner component — calls useLazyLoadQuery (may suspend or throw on error).
 * Must not be rendered directly; always wrap with AgentSessionsFetcher.
 */ function $ac96fb5095c0413f$var$AgentSessionsFetcherInner({ pageId: pageId, children: children, refetchOnMount: refetchOnMount, preserveEmptyMarker: preserveEmptyMarker }) {
    const sessionMap = (0, $cvIm8.usePageCommentAgentSessionsInner)(pageId, {
        refetchOnMount: refetchOnMount
    });
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: pageId,
        contentType: 'page'
    });
    (0, $cozmU.useEffect)(()=>{
        if (sessionMap.size > 0 || !userId || preserveEmptyMarker) return;
        // The sessions query came back empty. Don't delete the marker immediately: right after an
        // agent-mention comment is saved the backend creates the SessionAssociationPublic
        // asynchronously, so the query is briefly empty while usePageCommentAgentSessionsInner polls
        // for it. Defer the delete past that poll window — if a session shows up the map size
        // changes, this effect re-runs and the cleanup cancels the pending delete, so the
        // freshly-written marker is preserved (and the next page load still shows the session). Only
        // a marker that stays empty through the whole window is genuinely stale and gets cleaned up.
        const deleteMarkerTimer = setTimeout(()=>{
            updateContentProperty({
                propertyKey: `cc-agent-mention-sessions:${userId}`,
                isDelete: true
            });
        }, $ac96fb5095c0413f$var$MARKER_DELETE_DELAY_MS);
        return ()=>clearTimeout(deleteMarkerTimer);
    // Depend on sessionMap.size, not sessionMap: buildSessionMap returns a new Map
    // instance on every render even when data is unchanged, so using the Map reference
    // as a dep would fire this effect on every re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        preserveEmptyMarker,
        sessionMap.size,
        updateContentProperty,
        userId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FXhW.AgentSessionsContext).Provider, {
        value: sessionMap
    }, children);
}
function $ac96fb5095c0413f$export$4d8c455866c22554({ pageId: pageId, children: children, refetchOnMount: refetchOnMount = false, preserveEmptyMarker: preserveEmptyMarker = false }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac96fb5095c0413f$var$AgentSessionsFetcherInner, {
        pageId: pageId,
        refetchOnMount: refetchOnMount,
        preserveEmptyMarker: preserveEmptyMarker
    }, children)));
}



var $gXKuh = parcelRequire("gXKuh");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $bDgLe = parcelRequire("bDgLe");





var $4ez2K = parcelRequire("4ez2K");


var $iMnC5 = parcelRequire("iMnC5");

















var $ln0hx = parcelRequire("ln0hx");





var $jmjWc = parcelRequire("jmjWc");














var $lpNn5 = parcelRequire("lpNn5");





var $famWw = parcelRequire("famWw");





var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $c5b321ea0eb33bcf$var$i18n = (0, $kSwu1.defineMessages)({
    addCommentTooltip: {
        id: "object-comments.footer.add-button-tooltip",
        defaultMessage: "Add comment"
    }
});
const $c5b321ea0eb33bcf$export$ba63fdcb08237d72 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { onClick: onClick, autofocusRef: autofocusRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
        };
        $[0] = t1;
    } else t1 = $[0];
    const addCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t1);
    const buttonRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[1] !== autofocusRef) {
        t2 = ()=>{
            if (autofocusRef.current) {
                buttonRef.current?.focus({
                    preventScroll: true
                });
                autofocusRef.current = false;
            }
        };
        t3 = [
            autofocusRef
        ];
        $[1] = autofocusRef;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] !== formatMessage) {
        t4 = (0, $6mKj3.expValEquals)("confluence_comments_cohiti_footer_tooltips", "isEnabled", true) ? formatMessage($c5b321ea0eb33bcf$var$i18n.addCommentTooltip) : undefined;
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== autofocusRef || $[7] !== onClick) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $famWw.AddCommentPromptButton), {
            onClick: onClick,
            autofocusRef: autofocusRef,
            testId: "add-comment-button"
        });
        $[6] = autofocusRef;
        $[7] = onClick;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== addCommentShortcutStrings || $[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t4,
            shortcut: addCommentShortcutStrings,
            position: "top"
        }, t5));
        $[9] = addCommentShortcutStrings;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};












var $b35Wv = parcelRequire("b35Wv");


var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $9sGCn = parcelRequire("9sGCn");





var $7QM6o = parcelRequire("7QM6o");




const $2c779d914e38fe28$var$i18n = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "object-comments.page.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "object-comments.page.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $2c779d914e38fe28$export$3b5f3f6ec721f20a = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isOffline: t1, optimisticReactions: t2 } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const optimisticReactions = t2 === undefined ? false : t2;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    let t3;
    if ($[0] !== contentId) {
        t3 = (0, $9sGCn.getCachedPageData)(contentId);
        $[0] = contentId;
        $[1] = t3;
    } else t3 = $[1];
    const { subType: subType } = t3;
    let t4;
    if ($[2] !== formatMessage) {
        t4 = formatMessage($2c779d914e38fe28$var$i18n.addReaction);
        $[2] = formatMessage;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: t4
        });
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const customIcon = t5;
    const t6 = contentId || "";
    const t7 = contentType === "blogpost" ? (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST : (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE;
    const t8 = spaceId || "";
    let t9;
    if ($[6] !== formatMessage) {
        t9 = formatMessage($2c779d914e38fe28$var$i18n.addNew);
        $[6] = formatMessage;
        $[7] = t9;
    } else t9 = $[7];
    const t10 = isReactionsEnabled ? customIcon : undefined;
    let t11;
    if ($[8] !== customIcon || $[9] !== isOffline || $[10] !== optimisticReactions || $[11] !== subType || $[12] !== t10 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1NF8X.ReactionsLoader), {
            contentId: t6,
            location: t7,
            containerId: t8,
            containerType: (0, $3FlVr.ReactionContainerType).SPACE,
            contentSubType: subType,
            summaryViewEnabled: true,
            summaryViewThreshold: 1,
            allowSelectFromSummaryView: true,
            useButtonAlignmentStyling: true,
            summaryViewPlacement: "bottom-end",
            readOnly: isOffline,
            isViewOnly: isOffline,
            isSubtle: true,
            reactionPickerTriggerIcon: customIcon,
            reactionPickerTriggerText: t9,
            useDefaultStyledContainer: false,
            hidePlaceholder: Boolean(window.__SSR_RENDERED__),
            noRelativeContainer: false,
            noFlexWrap: false,
            hoverableSummaryView: true,
            reactionPickerPlacement: "bottom-end",
            summaryButtonIconAfter: t10,
            optimisticallyLoadSummaryEmojis: optimisticReactions,
            renderParticleEffectOnSummaryView: true
        });
        $[8] = customIcon;
        $[9] = isOffline;
        $[10] = optimisticReactions;
        $[11] = subType;
        $[12] = t10;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
        $[17] = t11;
    } else t11 = $[17];
    return t11;
};



const $2998c7377d5266d6$var$FooterLabelsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zM3y-",
    name: "FooterLabelsLoader",
    loader: async ()=>(await (parcelRequire("l3kuI"))).FooterLabels
});
const $2998c7377d5266d6$var$styles = {
    addCommentContainerStyles: "_1yt4pxbi _x3doia51 _kqsw1if8 _94n5ze3t _1e0c1txw _1bsb1osq _bfhkvuon",
    addCommentClosedContainerStyles: "_1bsb1osq _1e0c1txw _1bah1yb4 _4cvr1h6o _1o9zidpf",
    addCommentReactionsContainerStyles: "_1e0c1txw _4cvr1h6o _1bahesu3",
    rightButtonContainerStyles: "_4cvr1h6o"
};
const $2998c7377d5266d6$export$5ed9c7f27c15b7fe = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { showReactions: showReactions, showLabels: showLabels, isOffline: isOffline, optimisticReactions: t1 } = t0;
    const optimisticReactions = t1 === undefined ? false : t1;
    const shouldAutofocusPromptRef = (0, $cozmU.useRef)(false);
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== setFooterEditorEntry) {
        t2 = ()=>{
            expandCommentContainer({
                entryPoint: "pageFooter"
            });
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
        };
        $[0] = expandCommentContainer;
        $[1] = setFooterEditorEntry;
        $[2] = t2;
    } else t2 = $[2];
    const handleExpandCommentContainer = t2;
    let t3;
    if ($[3] !== contentId || $[4] !== expanded || $[5] !== handleExpandCommentContainer || $[6] !== isOffline || $[7] !== optimisticReactions || $[8] !== showLabels || $[9] !== showReactions) {
        t3 = !expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.addCommentClosedContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5b321ea0eb33bcf$export$ba63fdcb08237d72), {
            onClick: handleExpandCommentContainer,
            autofocusRef: shouldAutofocusPromptRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            testId: "objectAddCommentContainer-rightButtonContainer",
            xcss: $2998c7377d5266d6$var$styles.rightButtonContainerStyles
        }, showLabels && (0, $9wGTI.fg)("confluence_frontend_labels_in_footer") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2998c7377d5266d6$var$FooterLabelsLoader, null)), showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.addCommentReactionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline,
            optimisticReactions: optimisticReactions
        }))));
        $[3] = contentId;
        $[4] = expanded;
        $[5] = handleExpandCommentContainer;
        $[6] = isOffline;
        $[7] = optimisticReactions;
        $[8] = showLabels;
        $[9] = showReactions;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            id: "addCommentButton",
            xcss: $2998c7377d5266d6$var$styles.addCommentContainerStyles,
            testId: "addCommentButton"
        }, t3));
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
};
const $2998c7377d5266d6$export$f3a35a1c0e5d2996 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})($2998c7377d5266d6$export$5ed9c7f27c15b7fe);












var $3cu4A = parcelRequire("3cu4A");


var $7qvmT = parcelRequire("7qvmT");

















var $6Pqow = parcelRequire("6Pqow");


var $kA6Zo = parcelRequire("kA6Zo");


var $hMaHH = parcelRequire("hMaHH");








var $cAdj8 = parcelRequire("cAdj8");


var $dANtQ = parcelRequire("dANtQ");


var $3ejfs = parcelRequire("3ejfs");














var $i8TeS = parcelRequire("i8TeS");


var $cZRYC = parcelRequire("cZRYC");











var $7wP5b = parcelRequire("7wP5b");


var $ibqdE = parcelRequire("ibqdE");

/**
 * @generated SignedSource<<af601d1c4ff54d1ee14ab40f03d6343d>>
 * @relayHash 9fe996eb874f5dede5dfc631ede9be23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006
const $db736b7a8747d643$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9fe996eb874f5dede5dfc631ede9be23",
            "id": "2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006",
            "metadata": {},
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$db736b7a8747d643$var$node.hash = "70583226681dc587971b709a0fb5f1db";
var $db736b7a8747d643$export$2e2bcd8739ae039 = $db736b7a8747d643$var$node;


/**
 * @generated SignedSource<<ca37f2645dc8fcae1fb0169b2b6d90eb>>
 * @relayHash b4e5556f7ff0caaaa5f1f415e0fac219
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9fa83969df6abf4d4b492477645bde3a26b2e75d7cfa9ff354ba53793c159bf
const $c485e89730d7822c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ReopenCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b4e5556f7ff0caaaa5f1f415e0fac219",
            "id": "e9fa83969df6abf4d4b492477645bde3a26b2e75d7cfa9ff354ba53793c159bf",
            "metadata": {},
            "name": "ObjectCommentReopenCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentReopenCommentMutation($commentId:ID!,$cloudId:ID!){confluence_reopenComment(commentId:$commentId,cloudId:$cloudId){success,commentResolutionStates{commentId,status},errors{message,extensions{...on ReopenCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$c485e89730d7822c$var$node.hash = "08b0a438d17f5dfc7506b876a28c3269";
var $c485e89730d7822c$export$2e2bcd8739ae039 = $c485e89730d7822c$var$node;


/**
 * @generated SignedSource<<7671439f51f98ccffffbe6f6978d5c7d>>
 * @relayHash a8f662ea3948cbf66f23cd060b8803dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92
const $b2dfa720986474e4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentIds"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentIds",
            "variableName": "commentIds"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "resolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedFriendlyDate"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ResolveCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a8f662ea3948cbf66f23cd060b8803dd",
            "id": "2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92",
            "metadata": {},
            "name": "ObjectCommentResolveCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$b2dfa720986474e4$var$node.hash = "b22b5ff3d19850498d8af166b371db75";
var $b2dfa720986474e4$export$2e2bcd8739ae039 = $b2dfa720986474e4$var$node;









var $9DHhW = parcelRequire("9DHhW");


var $3ZsvI = parcelRequire("3ZsvI");





var $NYiei = parcelRequire("NYiei");


var $jbF1h = parcelRequire("jbF1h");











var $bSvtO = parcelRequire("bSvtO");





var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $1Sjzs = parcelRequire("1Sjzs");


var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");


var $cHfPA = parcelRequire("cHfPA");





var $3s9yq = parcelRequire("3s9yq");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $liGyh = parcelRequire("liGyh");


var $7aw3q = parcelRequire("7aw3q");

















var $9CnRS = parcelRequire("9CnRS");





var $87CZC = parcelRequire("87CZC");














var $fy5yb = parcelRequire("fy5yb");





var $en1dX = parcelRequire("en1dX");





var $6tkbf = parcelRequire("6tkbf");





var $cTi4A = parcelRequire("cTi4A");





var $mzXSs = parcelRequire("mzXSs");


var $308Wd = parcelRequire("308Wd");

const $972174ea64671f70$var$ObjectCommentResolveCommentMutation = (0, $b2dfa720986474e4$export$2e2bcd8739ae039);
const $972174ea64671f70$var$ObjectCommentReopenCommentMutation = (0, $c485e89730d7822c$export$2e2bcd8739ae039);
const $972174ea64671f70$var$ObjectCommentDeleteGeneralCommentMutation = (0, $db736b7a8747d643$export$2e2bcd8739ae039);
const $972174ea64671f70$var$i18n = (0, $kSwu1.defineMessages)({
    commentReopenedFlagTitle: {
        id: "object-comments.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "object-comments.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    commentReopenCacheUpdateFailedFlagTitle: {
        id: "object-comments.comment.reopen.cache-update.failed.flag.title",
        defaultMessage: "Failed to update reopened comment. Please refresh the page."
    },
    retryCTA: {
        id: "object-comments.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    }
});
const $972174ea64671f70$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $972174ea64671f70$export$f8aa7c43d6421d1d = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, isHovered: isHovered, threadKey: threadKey, flags: flags, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, adjustForFooterNestedReplies: adjustForFooterNestedReplies = false, topLevelParentCommentId: topLevelParentCommentId, commentHasChildren: commentHasChildren = false, isLastNestedFooterReply: isLastNestedFooterReply = false, isOffline: isOffline = false, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, replyHasNestedObjects: replyHasNestedObjects = false })=>{
    // Store stable references to break circular dependency in useCallback
    const handleResolveCommentRef = (0, $cozmU.useRef)(null);
    const handleReopenCommentRef = (0, $cozmU.useRef)(null);
    const { isReactionsEnabled: isReactionsEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ commentsDataMap: legacyCommentsDataMap, hasNestedComments: legacyHasNestedComments, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, deleteParentComment: deleteParentComment, handleRemovingComments: handleRemovingComments }] = (0, $8i27m.useCommentsData)();
    const { setCacheUpdateFailed: setCacheUpdateFailed } = (0, $8i27m.useCommentsDataActions)();
    // Get cache operations for new comments data manager
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Use new or legacy data based on experiment
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    // Use new or legacy hasNestedComments based on experiment
    const hasNestedComments = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, footerEditCommentIds: footerEditCommentIds }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, addFooterEditCommentId: addFooterEditCommentId, removeFooterEditCommentId: removeFooterEditCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const [resolveCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentResolveCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    const resolveCommentMutationFn = resolveCommentFn;
    const [reopenCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentReopenCommentMutation, {
        refetchQueries: // Copied from the existing dialog flow to support standalone experience
        pageMode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? [
            {
                query: (0, $3s9yq.InlineCommentsQuery),
                variables: {
                    pageId: contentId
                }
            }
        ] : [],
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    // Get the update functions for the comments data manager - aliased to support the different
    // mutation's different result types
    const { updateCommentInCache: updateResolveCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateReopenCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const [deleteGeneralCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentDeleteGeneralCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAt = comment?.createdAt?.value;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0;
    const commentUrl = comment?.links.webui ?? undefined;
    const inheritedReactionsData = comment?.reactionsSummary;
    const footerCommentLocation = comment?.location;
    const getResolvedProperties = (0, $cozmU.useCallback)(()=>{
        const properties = footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties();
    const isCommentRemovedByAnotherUser = comment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    const isDeletedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
    const deleteCommentInCacheOnUpdate = (0, $cozmU.useCallback)((removalCommentId)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                if ((0, $6mKj3.expValEquals)('confluence_fe_handle_use_all_comments_cache_miss', 'isEnabled', true)) flags?.showWarningFlag({
                    id: 'delete-comment-in-cache-error',
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).networkError)
                });
                else (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker,
        flags
    ]);
    // This used to be behind confluence_frontend_content_wrapper, but that gate is rolled out.
    // Keeping this as a single variable keeps experiment exposures constant, and the `|| false`
    // avoids feature-gating ratcheting concerns until confluence_fe_delete_comment_optimistic is cleaned up.
    const isOptimisticDeleteEnabled = (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false) || false;
    const nonMemoizedHandleDeleteGeneralComment = ()=>{
        let deleteLocation;
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId), ()=>isReply ? (0, $87CZC.updateApolloCacheReplyCallback)('delete', {
                    pageId: contentId,
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ],
                    type: [
                        'FOOTER'
                    ]
                }, parentCommentId, isReactionsEnabled, commentId) : (0, $87CZC.updateApolloCacheParentCallback)('delete', {
                    pageId: contentId,
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ],
                    type: [
                        'FOOTER'
                    ]
                }, isReactionsEnabled, commentId)),
            optimisticResponse: isOptimisticDeleteEnabled ? {
                deleteComment: true
            } : undefined
        };
        // Optimistically delete the comment thread, if it is not a reply.
        const deletedParentComment = !isReply && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteParentCommentOptimistically)({
            threadKey: threadKey,
            commentType: (0, $8i27m.CommentType).GENERAL,
            commentsDataMap: commentsDataMap,
            deleteParentComment: deleteParentComment
        }) : null;
        // Optimistically delete the reply, if it is a reply.
        const deletedReplyComment = isReply && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: threadKey,
            commentId: commentId,
            commentType: (0, $8i27m.CommentType).GENERAL,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            if (!isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (isReply) handleRemovingComments({
                    threadKey: threadKey,
                    commentId: commentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).GENERAL
                });
                else deleteParentComment({
                    threadKey: threadKey,
                    commentType: (0, $8i27m.CommentType).GENERAL
                });
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: (0, $en1dX.CommentType).PAGE,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        pageMode: pageMode,
                        isReply: isReply
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err_0)=>{
            const parsedError = (0, $isdzP.parseError)(err_0);
            const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
            if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                flags?.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'alreadyDeleted',
                        actionSubject: 'comment',
                        actionSubjectId: commentId,
                        objectType: 'page',
                        objectId: contentId,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        attributes: {
                            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                            commentType: (0, $8i27m.CommentType).GENERAL,
                            source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                            mode: pageMode,
                            isReply: isReply
                        }
                    }
                }).fire();
            } else if (isOptimisticDeleteEnabled) // show an error flag to the user when optimistic deletion fails
            flags?.showErrorFlag({
                id: commentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).deleteError)
            });
            // add back the optimistically deleted comment or reply
            if (deletedParentComment && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads(deletedParentComment);
            if (deletedReplyComment && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(threadKey, deletedReplyComment, (0, $8i27m.CommentType).GENERAL, true);
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                error: err_0,
                commentId: commentId
            });
        });
    };
    const memoizedHandleDeleteGeneralComment = (0, $cozmU.useCallback)(nonMemoizedHandleDeleteGeneralComment, [
        commentId,
        createAnalyticsEvent,
        deleteGeneralCommentFn,
        deleteParentComment,
        deleteCommentInCacheOnUpdate,
        experienceTracker,
        flags,
        handleRemovingComments,
        isReactionsEnabled,
        isReply,
        contentId,
        pageMode,
        parentCommentId,
        resetContentChanged,
        threadKey,
        isOptimisticDeleteEnabled,
        addNewCommentThreads,
        addReplyToCommentThread,
        commentsDataMap
    ]);
    /**
   * editComment, deleteComment, and resolveComment cause instability in CommentBody when rendering. Although
   * useStableCallback would be more ideal to simplify the overhead for consumers of CommentBody, these functions
   * as props are used as proxies for permissions meaning they could be undefined which violates the typing for useStableCallback
   */ const handleDeleteGeneralComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleDeleteGeneralComment : nonMemoizedHandleDeleteGeneralComment;
    const nonMemoHandleEditComment = ()=>{
        addFooterEditCommentId(commentId);
    };
    const memoizedHandleEditComment = (0, $cozmU.useCallback)(nonMemoHandleEditComment, [
        addFooterEditCommentId,
        commentId
    ]);
    const handleEditComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleEditComment : nonMemoHandleEditComment;
    const exitCommentEditor = ()=>{
        removeFooterEditCommentId(commentId);
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            // If we allow nested comments, reply directly to the comment (set in CommentActions)
            // Otherwise, reply to the to the parent comment
            parentCommentId: hasNestedComments ? id : topLevelParentCommentId || id,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            user: {
                // This field controls who we auto mention in the reply
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            }
        });
    };
    const handleReopenMutationFailure = (0, $cozmU.useCallback)(({ isCacheUpdateFailed: isCacheUpdateFailed })=>{
        // TODO: Add experience tracking for reopening, which will allow us to differentiate and
        // detect cache errors vs mutation errors by the error value in the stopOnError() experience
        // call.  When that is added, we can go back to having a single flag message.
        flags?.showErrorFlag({
            id: commentId,
            title: formatMessage(isCacheUpdateFailed ? $972174ea64671f70$var$i18n.commentReopenCacheUpdateFailedFlagTitle : $972174ea64671f70$var$i18n.commentReopenFailedFlagTitle),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage($972174ea64671f70$var$i18n.retryCTA),
                    onClick: ()=>{
                        flags.hideFlag(flags.state.flags[0]?.id);
                        handleReopenCommentRef.current?.();
                    }
                }
            ]
        });
    }, [
        commentId,
        flags,
        formatMessage
    ]);
    const reopenCommentUpdateFn = (0, $cozmU.useCallback)((_dataProxy, mutationResult)=>updateReopenCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.reopenCommentInCacheCallback),
            onError: ()=>handleReopenMutationFailure({
                    isCacheUpdateFailed: true
                })
        }), [
        commentId,
        handleReopenMutationFailure,
        updateReopenCommentInCache
    ]);
    const nonMemoHandleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            },
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? reopenCommentUpdateFn : undefined
        }).then(()=>{
            // Update the state for panel experience
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
                else {
                    const commentsDataMapClone = {
                        ...commentsDataMap
                    };
                    const commentInMap = commentsDataMapClone[(0, $8i27m.CommentType).GENERAL][threadKey];
                    if (commentInMap) {
                        commentInMap.isOpen = true;
                        commentInMap.wasRemovedByAnotherUser = false;
                        addNewCommentThreads(commentsDataMapClone);
                        const commentLocation = commentInMap.location;
                        if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = false;
                    }
                }
            }
            // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($972174ea64671f70$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).OPEN);
                            if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
        }).catch(()=>{
            handleReopenMutationFailure({
                isCacheUpdateFailed: false
            });
        });
    };
    const memoHandleReopenComment = (0, $cozmU.useCallback)(nonMemoHandleReopenComment, [
        addNewCommentThreads,
        cloudId,
        commentId,
        commentsDataMap,
        flags,
        formatMessage,
        handleReopenMutationFailure,
        isCommentsPanelShown,
        reopenCommentFn,
        reopenCommentUpdateFn,
        setCurrentView,
        showCommentsPanel,
        threadKey
    ]);
    const handleResolveMutationFailure = (0, $cozmU.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
            error: resolveError
        });
    }, [
        experienceTracker
    ]);
    const resolveCommentsUpdateFn = (0, $cozmU.useCallback)((_dataProxy_0, mutationResult_0)=>updateResolveCommentInCache({
            mutationResult: mutationResult_0,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateResolveCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const nonMemoHandleResolveComment = ()=>{
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && (0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // Optimistically mark the comment as resolved in the data map & update UI early
        (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
        const mutationVariables = {
            commentIds: [
                commentId
            ],
            cloudId: cloudId
        };
        const query = (0, $b1hSc.default);
        const queryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
            pageId: contentId,
            type: 'FOOTER' // If we have footer, always write to footer. Panel works either way
        });
        // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentMutationFn({
            variables: mutationVariables,
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? resolveCommentsUpdateFn : (cache)=>{
                (0, $3ZsvI.updateCommentsQueryCacheForResolve)({
                    cache: cache,
                    commentId: commentId,
                    query: query,
                    queryVariables: queryVariables,
                    cacheUpdateFailed: cacheUpdateFailed,
                    setCacheUpdateFailed: setCacheUpdateFailed,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    logger: $972174ea64671f70$var$logger
                });
            },
            // When a `optimisticResponse` is set, useMutation invokes the update function twice:
            // first immediately, and after mutation succeeds, a second time. If mutation fails,
            // the cache updated by the update function is rolled back. Thus, this optimistic
            // resolve works both when cc_comments_new_comments_data_manager is ON and OFF.
            optimisticResponse: (0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false) ? {
                confluence_resolveComments: {
                    commentResolutionStates: [
                        {
                            commentId: commentId,
                            status: true,
                            resolveProperties: {
                                // These 2 values will be updated to the correct value after mutation succeeds.
                                // - `resolvedUser` is only displayed in comments panel Resolved view,
                                //   inside a tooltip when hovered.
                                // - `resolvedFriendlyDate` is part of the mutation payload, but the current UI
                                //   displays `resolvedTime`.
                                // So setting it as empty optimistically won't affect the static UI.
                                resolvedUser: null,
                                resolvedFriendlyDate: '',
                                resolvedTime: Date.now(),
                                __typename: 'InlineCommentResolveProperties'
                            },
                            __typename: 'ConfluenceCommentResolutionState'
                        }
                    ],
                    success: true,
                    errors: [],
                    __typename: 'ConfluenceResolveCommentsPayload'
                }
            } : undefined
        }).then(()=>{
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                // Update the state for panel experience when optimistic resolve is disabled
                // If enabled, this has been done before the mutation succeeds.
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
                else {
                    const commentsDataMapClone_0 = {
                        ...commentsDataMap
                    };
                    const commentInMap_0 = commentsDataMapClone_0[(0, $8i27m.CommentType).GENERAL][threadKey];
                    if (commentInMap_0) {
                        commentsDataMapClone_0[(0, $8i27m.CommentType).GENERAL][threadKey].isOpen = false;
                        const commentLocation_0 = commentsDataMapClone_0[(0, $8i27m.CommentType).GENERAL][threadKey].location;
                        if (commentLocation_0 && commentLocation_0.commentResolveProperties) commentLocation_0.commentResolveProperties.resolved = true;
                        addNewCommentThreads(commentsDataMapClone_0);
                    }
                }
            }
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: contentId,
                pageMode: pageMode,
                source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                commentType: (0, $8i27m.CommentType).GENERAL,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (allowComments) flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).RESOLVED,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleReopenCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err_1)=>{
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // Undo resolving the comment when optimistic resolve is enabled
                (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, (0, $8i27m.CommentType).GENERAL, threadKey, addNewCommentThreads);
                // Show an error flag to user when resolve fails
                flags?.showErrorFlag({
                    id: commentId,
                    title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                    description: formatMessage((0, $9CnRS.i18n).resolveError)
                });
            }
            handleResolveMutationFailure(err_1);
        });
    };
    const memoizedHandleResolveComment = (0, $cozmU.useCallback)(nonMemoHandleResolveComment, [
        addNewCommentThreads,
        allowComments,
        cacheUpdateFailed,
        cloudId,
        commentId,
        commentsDataMap,
        createAnalyticsEvent,
        experienceTracker,
        flags,
        formatMessage,
        handleResolveMutationFailure,
        isCommentsPanelShown,
        contentId,
        pageMode,
        resolveCommentMutationFn,
        resolveCommentsUpdateFn,
        setCacheUpdateFailed,
        setCurrentView,
        showCommentsPanel,
        threadKey
    ]);
    const handleResolveComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleResolveComment : nonMemoHandleResolveComment;
    const handleReopenComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoHandleReopenComment : nonMemoHandleReopenComment;
    // Update refs to break circular dependency
    handleResolveCommentRef.current = handleResolveComment;
    handleReopenCommentRef.current = handleReopenComment;
    const pageType = pageInfo?.type ?? '';
    // Agent session — wire SSE state for the agent-mention-in-comment feature.
    // Any comment (top-level OR reply) can be associated with an agent session, so
    // each comment looks up its OWN session by commentId from AgentSessionsContext
    // (the map is keyed by the numeric comment id parsed from the session's
    // subEntityId ARI, populated by the page-level fetch). When there is no session
    // the hook is a no-op. The experiment is inlined per
    // confluence-feature-gating/inline-usage and ordered last (gate-last).
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    const agentSession = commentId ? agentSessions.get(commentId) : undefined;
    const { state: agentSessionState } = (0, $mzXSs.useCommentAgentSession)((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? commentId ?? '' : '', (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? agentSession?.conversationId : undefined, (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? agentSession?.state ?? undefined : undefined);
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op_1)=>op_1?.operation === 'create' && op_1?.targetType === 'attachment') || spaceOperations.some((op_0)=>op_0?.operation === 'create' && op_0?.targetType === 'attachment');
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const supportedActions = !isReply && isCommentRemovedByAnotherUser ? [
        'reopen'
    ] : supportedTopLevelActions;
    const commentContent = footerEditCommentIds?.has(commentId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auGhu.EditComment), {
        pageId: contentId,
        date: date ?? '',
        createdAtNonLocalized: createdAtNonLocalized,
        pageType: pageType,
        commentId: commentId,
        annotationId: threadKey,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        dateUrl: commentUrl ?? '',
        versionByDisplayName: versionByDisplayName ?? '',
        versionDate: versionDate ?? '',
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isFooterComment: true,
        commentType: (0, $8i27m.CommentType).GENERAL,
        adjustForFooterReplies: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? commentHasChildren || !isReply && numReplies > 0 : commentHasChildren || !isReply,
        isLastNestedFooterReply: isLastNestedFooterReply,
        isOffline: isOffline
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        annotationId: threadKey,
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAt: createdAt ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName ?? '',
        versionDate: versionDate ?? '',
        pageId: contentId,
        pageType: pageType,
        commentId: commentId ?? '',
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedActions,
        deleteComment: handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        isCommentsPanel: true,
        isHovered: isHovered,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        isFocused: isCommentFocused,
        resolveProperties: resolveProperties,
        replyToComment: handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        commentType: (0, $8i27m.CommentType).GENERAL,
        adjustForNestedReplies: adjustForNestedReplies,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: true,
        adjustForFooterNestedReplies: adjustForFooterNestedReplies,
        isOffline: isOffline,
        showRepliesWithCurvedBorders: showRepliesWithCurvedBorders,
        replyHasNestedObjects: replyHasNestedObjects,
        contributors: (0, $cHfPA.hasContributors)(comment) ? comment.contributors : undefined
    });
    // When this comment (top-level or reply) has an associated agent session, attach
    // the AvatarWithActionButton (from AFM PR #370723) BELOW the comment — the comment
    // still renders normally. The component drives its label/action off agentState.
    // Interim — prop values will be refined once the design branch is fully merged.
    // Gate inlined and ordered last per confluence-feature-gating rules.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, commentContent, agentSessionState && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && (isReply ? // Nested replies: wrap the status row in the same curved branch a reply uses so it
    // attaches to the thread's connector line. Top-level comments render it unwrapped.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? {
            left: '-16px',
            height: '24px'
        } : {
            height: '25px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTi4A.AvatarWithActionButtonAsync), {
        agentState: agentSessionState,
        conversationId: agentSession?.conversationId ?? '',
        userId: agentSession?.agentId ?? userId,
        avatarUrl: agentSession?.avatarUrl ?? topCommentUserAvatar,
        agentName: agentSession?.agentName ?? undefined,
        isReply: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTi4A.AvatarWithActionButtonAsync), {
        agentState: agentSessionState,
        conversationId: agentSession?.conversationId ?? '',
        userId: agentSession?.agentId ?? userId,
        avatarUrl: agentSession?.avatarUrl ?? topCommentUserAvatar,
        agentName: agentSession?.agentName ?? undefined
    })));
};












var $ad7Ou = parcelRequire("ad7Ou");








var $6faGq = parcelRequire("6faGq");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");














var $58Zuw = parcelRequire("58Zuw");


var $lLpk8 = parcelRequire("lLpk8");


var $8gR6k = parcelRequire("8gR6k");


var $jVIRU = parcelRequire("jVIRU");










/* ObjectCommentNestableReplies.tsx generated by @compiled/babel-plugin v0.40.0 */ 







































/**
 * @generated SignedSource<<2af211105f6fccbf5e567c13924a0e2f>>
 * @relayHash 1d9e1b43849e3df74cbece7106034480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a458ec6be112cd3ededf79466ea5c9786377fac3a29e8eb8df551b7938512f4
const $8e983492bd7543de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ],
                            "type": "KnownUser"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v3 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v3 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedFriendlyDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedUser"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolved"
                                        }
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "1d9e1b43849e3df74cbece7106034480",
            "id": "8a458ec6be112cd3ededf79466ea5c9786377fac3a29e8eb8df551b7938512f4",
            "metadata": {},
            "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentReplyEditorCreateGeneralReplyMutation($cloudId:ID!,$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number}}}"
        }
    };
}();
$8e983492bd7543de$var$node.hash = "bf58f0a383f4e192dfb098a8d5ea1e6c";
var $8e983492bd7543de$export$2e2bcd8739ae039 = $8e983492bd7543de$var$node;












var $g8bbY = parcelRequire("g8bbY");








var $hXzKU = parcelRequire("hXzKU");








var $ag51I = parcelRequire("ag51I");























var $hl1Kw = parcelRequire("hl1Kw");

















var $emtVP = parcelRequire("emtVP");

const $7c5ea6bb1ec976c9$var$ObjectCommentReplyEditorCreateGeneralReplyMutation = (0, $8e983492bd7543de$export$2e2bcd8739ae039);
const $7c5ea6bb1ec976c9$var$commentEditorWrapperStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $7c5ea6bb1ec976c9$var$commentEditorCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    // Be careful updating this, it can cause the branch to jump slightly when switching from the button to the editor
    height: '24px',
    marginRight: "var(--ds-space-050, 4px)"
};
const $7c5ea6bb1ec976c9$export$25e4139e54938aaf = ({ pageInfo: pageInfo, pageMode: pageMode, setReplyView: setReplyView, parentComment: parentComment, threadKey: threadKey, replyToId: replyToId, isOffline: isOffline, customBeforeLeftForNestedReply: customBeforeLeftForNestedReply })=>{
    const replyEditorContainerId = `object-comment-reply-editor-${replyToId}`;
    const [createGeneralReplyFn] = (0, $308Wd.useMutationInterop)($7c5ea6bb1ec976c9$var$ObjectCommentReplyEditorCreateGeneralReplyMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const spaceId = pageInfo?.space?.id ?? '';
    const commentType = parentComment.type;
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { addReplyToCommentThread: addReplyToCommentThread } = (0, $8i27m.useCommentsDataActions)();
    const [{ replyToCommentId: replyToCommentId, replyToCommentUser: replyToCommentUser, replyToContributorUsers: replyToContributorUsers }, { setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const [, setCommentForEdit] = (0, $cozmU.useState)('');
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // User page permissions
    const operations = pageInfo?.operations || [];
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op_1)=>op_1?.operation === 'create' && op_1?.targetType === 'attachment') || spaceOperations.some((op_0)=>op_0?.operation === 'create' && op_0?.targetType === 'attachment');
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    const onEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
        if (commentType === (0, $8i27m.CommentType).GENERAL) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
        experienceTracker.succeed({
            name: experienceName
        });
        const commentReplyContainer = typeof document !== 'undefined' ? document.getElementById(replyEditorContainerId) : null;
        if (!commentReplyContainer) return;
        // Check whether the bottom of the comment reply container is visible
        const isBottomOutOfView = commentReplyContainer.getBoundingClientRect().bottom > window.innerHeight;
        // Only scroll if we currently can't see the bottom of the comment reply container. It's annoying to always scroll
        if (isBottomOutOfView) commentReplyContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
        // Focus the editor to position cursor after the @mention
        if (editorActions?.focus) editorActions.focus();
    }, [
        commentType,
        experienceTracker,
        replyEditorContainerId
    ]);
    const handleCancelComment = (0, $cozmU.useCallback)(({ destroy: destroy = false } = {})=>{
        if (!destroy || replyToCommentId !== replyToId) setReplyToCommentId();
    }, [
        replyToCommentId,
        replyToId,
        setReplyToCommentId
    ]);
    const handleSaveComment = (0, $cozmU.useCallback)((adf, onSuccess)=>{
        // Wrap createFooterReplyFn to intercept the raw mutation result before
        // onSaveReply consumes it (onSaveReply's .then() returns undefined).
        // This lets us extract the new comment ID for the agent-mention tag.
        const wrappedCreateFooterReplyFn = (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? (...args)=>{
            const promise = createGeneralReplyFn(...args);
            promise?.then(({ data: data })=>{
                const commentId = data?.createFooterComment?.id ?? data?.replyInlineComment?.id ?? replyToId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId, userId ?? undefined);
            });
            return promise;
        } : createGeneralReplyFn;
        // Also wrap createObjectReplyFn — used when cc_comments_new_comments_data_manager
        // is enabled and takes precedence over createFooterReplyFn.
        // Using explicit if/else to avoid nested ternary (Sonar S3358).
        let wrappedCreateObjectReplyFn;
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) wrappedCreateObjectReplyFn = (...args_0)=>{
            const promise_0 = createObjectCommentMutationFn(...args_0);
            promise_0?.then(({ data: data_0 })=>{
                const commentId_0 = data_0?.createFooterComment?.id ?? data_0?.createObjectComment?.id ?? replyToId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId_0, userId ?? undefined);
            });
            return promise_0;
        };
        else if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) wrappedCreateObjectReplyFn = createObjectCommentMutationFn;
        else wrappedCreateObjectReplyFn = undefined;
        return (0, $7qvmT.onSaveReply)({
            pageId: pageId,
            parentCommentId: replyToId,
            cloudId: cloudId,
            adf: adf,
            onSuccess: onSuccess,
            pageMode: pageMode,
            setCommentForEdit: setCommentForEdit,
            createAnalyticsEvent: createAnalyticsEvent,
            pageType: pageType,
            experienceTracker: experienceTracker,
            createFooterReplyFn: wrappedCreateFooterReplyFn,
            createObjectReplyFn: wrappedCreateObjectReplyFn,
            addCommentInCommentsDataManagerCacheFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? addCommentInCache : undefined,
            addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
            threadKey: threadKey,
            commentType: commentType,
            searchSessionId: searchSessionId,
            isReactionsEnabled: isReactionsEnabled,
            setReplyView: setReplyView,
            setReplyToCommentId: setReplyToCommentId,
            resetContentChanged: resetContentChanged,
            analyticsSource: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
            isFooterComment: true,
            userId: userId,
            displayName: displayName
        });
    }, [
        threadKey,
        setReplyToCommentId,
        setReplyView,
        searchSessionId,
        resetContentChanged,
        replyToId,
        addReplyToCommentThread,
        cloudId,
        commentType,
        createAnalyticsEvent,
        createGeneralReplyFn,
        addCommentInCache,
        createObjectCommentMutationFn,
        experienceTracker,
        isReactionsEnabled,
        pageId,
        pageMode,
        pageType,
        userId,
        displayName
    ]);
    const commentEditorCommentType = commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : commentType;
    const commentEditorPageMode = pageMode === 'edit' ? 'edit' : 'view';
    const editorContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $7c5ea6bb1ec976c9$var$commentEditorWrapperStyles,
        id: replyEditorContainerId,
        testId: replyEditorContainerId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        content: (0, $7qvmT.getReplyEditorContent)({
            replyToCommentUser: replyToCommentUser,
            replyToContributorUsers: replyToContributorUsers
        }),
        appearance: "comment",
        EditorComponent: (0, $g8bbY.CommentEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        onEditorReady: onEditorReady,
        commentMode: "reply",
        commentType: commentEditorCommentType,
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: true,
        pageMode: commentEditorPageMode,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        topLevelCommentId: parentComment.id,
        shouldWarnOnInternalNavigation: true,
        onCancelComment: handleCancelComment,
        isCommentsPanel: false,
        isFooterComment: true,
        wasRemovedByAnotherUser: parentComment.wasRemovedByAnotherUser,
        isOffline: isOffline
    }));
    if (!replyToCommentId) return null;
    return (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? editorContainer : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: {
            ...$7c5ea6bb1ec976c9$var$commentEditorCustomStyles,
            ...customBeforeLeftForNestedReply && {
                left: '-25px'
            }
        }
    }, editorContainer);
};


'use no memo';
const $535a8f2c4921cd54$var$replyBoxStyles = null;
const $535a8f2c4921cd54$var$replyBoxStylesV2 = null;
const $535a8f2c4921cd54$var$objectCommentWrapperStyles = null;
const $535a8f2c4921cd54$var$nestedReplyThreadBoxStyles = null;
const $535a8f2c4921cd54$var$nestedReplyThreadBoxStylesV2 = null;
const $535a8f2c4921cd54$var$topLevelReplyThreadBoxStyles = null;
const $535a8f2c4921cd54$var$withLeftBorderStyle = null;
const $535a8f2c4921cd54$var$withLeftBorderStyleUpdated = null;
const $535a8f2c4921cd54$var$withLeftBoxShadow = null;
const $535a8f2c4921cd54$var$footerReplyContainerStyle = null;
const $535a8f2c4921cd54$var$footerReplyContainerStyleUpdated = null; // Curved branch styles for connecting replies
const $535a8f2c4921cd54$var$replyBranchStyles = null;
const $535a8f2c4921cd54$var$replyBranchStylesUpdated = null;
const $535a8f2c4921cd54$var$i18n = (0, $kSwu1.defineMessages)({
    replyAriaLabel: {
        id: "object-comments.reply.aria-label",
        defaultMessage: "Reply by {authorName}, {timestamp}"
    }
});
const $535a8f2c4921cd54$export$4c583da0a4f30f74 = ({ parentReplyId: parentReplyId, parentToRepliesMap: parentToRepliesMap, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, pageInfo: pageInfo, pageMode: pageMode, threadKey: threadKey, supportedTopLevelActions: supportedTopLevelActions, hoveredCommentId: hoveredCommentId, isTopLevelReply: isTopLevelReply, parentComment: parentComment, parentReplyButtonAllowed: parentReplyButtonAllowed, setReplyView: setReplyView, isOffline: isOffline, flags: flags, isEditorExpanded: isEditorExpanded })=>{
    const { replyToCommentId: replyToCommentId, location: location, footerEditCommentIds: footerEditCommentIds } = (0, $3mVfX.useCommentsPanelState)();
    const { hasNestedComments: legacyHasNestedComments } = (0, $8i27m.useCommentsDataState)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const hasNestedComments = (0, $6mKj3.expValEquals)('cc_comments_new_comments_data_manager', 'isEnabled', true) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const [commentIsFocused, setCommentIsFocused] = (0, $cozmU.useState)(null);
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl; // A reply renders its agent-session status (AvatarWithActionButton) below itself. Read the
    // page's agent-session map so we can keep the thread's connector line visible for such a
    // reply (mirrors ObjectCommentThread's parentHasAgentSession for the top-level comment) —
    // otherwise the status floats with no line when the reply is the last in the thread.
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const isParentCommentOpen = parentComment.isOpen;
    const repliesToRender = parentToRepliesMap[parentReplyId];
    const handleFocus = (0, $cozmU.useCallback)((event, replyId)=>{
        event.stopPropagation();
        setCommentIsFocused(replyId);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $cozmU.useCallback)((event_0)=>{
        // Only clear focus if we're not focusing a child element
        if (!event_0.relatedTarget || !event_0.currentTarget.contains(event_0.relatedTarget)) setCommentIsFocused(null);
    }, [
        setCommentIsFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testId": "footer-reply-container",
        role: "list",
        className: (0, $hekY6.default)([
            isTopLevelReply ? "_1e0c1txw _2lx21bp4" : "_1e0c1txw _2lx21bp4 _18u0pxbi",
            isTopLevelReply && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_kqswh2mm _1n1j11qs _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _19woidpf",
            isTopLevelReply && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1n1j1h4i"
        ])
    }, repliesToRender.map((reply, idx)=>{
        // These all control the visibility of the reply editor and left border
        // Generally speaking, we want to show the left border at the thread level rather than from comment body (showLeftBorder)
        // However, if one of the comment's will not have a left border (for example, if it's the last reply), we need to show at the comment level (!hideBranchingStyle)
        const replyHasChildren = parentToRepliesMap[reply.id]?.length > 0;
        const isLastReply = idx === repliesToRender.length - 1;
        const isFooterReplyMatchingReplyToCommentParameter = reply.id === replyToCommentId && location === (0, $i6UMJ.LocationValue).FOOTER;
        const showReplyEditor = hasNestedComments && isFooterReplyMatchingReplyToCommentParameter;
        const parentReplyButtonVisible = parentReplyButtonAllowed && isTopLevelReply; // This reply renders an agent-session status row below it; used to keep the connector
        // line visible. Gate inlined, ordered last per feature-gating rules.
        const replyHasAgentSession = Boolean(agentSessions.get(reply.id)) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true);
        const replyHasNestedObjects = replyHasChildren || showReplyEditor; // The agent status row adds height below the reply that the thread's connector line
        // must span. Treat it like a nested object for the BORDER only (not the body margin
        // `replyHasNestedObjects`, which would shift layout) — otherwise the line breaks
        // between this reply's status row and the next reply.
        const replyHasNestedObjectsOrAgent = replyHasNestedObjects || replyHasAgentSession;
        const replyIsBeingEdited = footerEditCommentIds?.has(reply.id);
        const showLeftBorder = parentReplyButtonVisible || replyHasNestedObjectsOrAgent && !isLastReply || replyIsBeingEdited && !isLastReply; // Keep the connector line visible when the reply has an agent session, even when it is
        // the last reply (where branching is normally hidden), so the status row stays attached.
        const hideBranchingStyle = !replyHasAgentSession && ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? isLastReply && (!isTopLevelReply || !isEditorExpanded) : parentReplyButtonVisible || replyHasNestedObjects || !parentReplyButtonVisible && isLastReply); // This moves the branching style 1px to the left to account for the 1px left border of the thread
        const adjustForFooterNestedReplies = hideBranchingStyle && (!isLastReply || parentReplyButtonVisible); // This accounts for the 1px missing border offset of the last reply in a deeply nested thread
        const isLastNestedFooterReply = isLastReply && !isTopLevelReply;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // Note: Cannot set `key` to `reply.id`, which, when optimistic save (COMMENTS-6792)
        , {
            // is enabled, is the fake optimistic id first and then gets updated to the actual
            // new comment id after mutation succeeds.
            // When mutation succeeds, DOM tree is updated. If `key` stays the same, the update
            // is recognized as multiple individual "mutation:attribute" for known attributes
            // excluded from VC calculation (e.g. data-testid); if key changes, the update is
            // recognized as a replacement of the entire element tree and counted in VC.
            // Unlike `reply.id`, `idx` is stable as long as the reply's position in the list
            // does not change.
            key: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-replies-${idx}`,
            id: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${reply.id}-replies`,
            "data-testid": `comment-thread-${parentReplyId}-replies-${reply.id}`,
            onMouseEnter: ()=>handleMouseEnter(reply.id),
            onMouseLeave: handleMouseLeave,
            onFocus: (event_1)=>handleFocus(event_1, reply.id),
            onBlur: handleBlur,
            role: "listitem",
            "aria-label": formatMessage($535a8f2c4921cd54$var$i18n.replyAriaLabel, {
                authorName: reply.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
                timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                    intl: intl,
                    dateString: reply.createdAtNonLocalized,
                    isReply: true
                })
            }),
            className: (0, $hekY6.default)([
                "_qtt8glyw _kqswh2mm _19bv1ejb",
                (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvpxbi",
                "_kqswh2mm _1n1j11qs _4k1c11qs _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _1mp41gif _kfgt1tcg _fik81mok _13y0usvi",
                (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1n1j1h4i _4k1c1h4i",
                showLeftBorder && replyHasNestedObjectsOrAgent && (!isLastReply || isLastReply && isEditorExpanded || !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) && "_16qsuq84",
                replyIsBeingEdited && !isLastReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_16qsuq84"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                !replyIsBeingEdited && "_n3tdu2gc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
            comment: reply,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(reply.id),
            isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === reply.id || commentIsFocused === reply.id,
            threadKey: threadKey,
            hideBranchingStyle: hideBranchingStyle,
            adjustForNestedReplies: false,
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            adjustForFooterNestedReplies: false,
            topLevelParentCommentId: parentComment.id,
            commentHasChildren: replyHasChildren,
            isLastNestedFooterReply: isLastNestedFooterReply,
            flags: flags,
            showRepliesWithCurvedBorders: false,
            replyHasNestedObjects: replyHasNestedObjects
        })), showReplyEditor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _2lx21bp4 _18u0pxbi",
                replyHasChildren && "_1kl711qs",
                replyHasChildren && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1kl71h4i",
                replyHasChildren && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvv47k"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
            pageInfo: pageInfo,
            pageMode: pageMode,
            setReplyView: setReplyView,
            parentComment: parentComment,
            threadKey: threadKey,
            replyToId: reply.id,
            isOffline: isOffline,
            customBeforeLeftForNestedReply: adjustForFooterNestedReplies
        })), parentToRepliesMap[reply.id]?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($535a8f2c4921cd54$export$4c583da0a4f30f74, {
            parentReplyId: reply.id,
            parentToRepliesMap: parentToRepliesMap,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            canAddComments: canAddComments,
            pageInfo: pageInfo,
            pageMode: pageMode,
            threadKey: threadKey,
            supportedTopLevelActions: supportedTopLevelActions,
            hoveredCommentId: hoveredCommentId,
            isTopLevelReply: false,
            parentComment: parentComment,
            parentReplyButtonAllowed: false,
            setReplyView: setReplyView,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        }));
    }));
};



const $b210b13432f2522a$var$replyActionButtonStyles = {
    marginLeft: "var(--ds-space-150, 12px)",
    width: '62px',
    height: '24px',
    left: '-12px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)"
};
const $b210b13432f2522a$var$i18n = (0, $kSwu1.defineMessages)({
    replyAction: {
        id: "object-comments.reply.action",
        defaultMessage: "Reply"
    }
});
const $b210b13432f2522a$export$55de1ed49e182c87 = (t0)=>{
    const $ = (0, $bDgLe.c)(117);
    const { parentComment: parentComment, pageInfo: pageInfo, hoveredCommentId: hoveredCommentId, pageMode: pageMode, parentCommentId: parentCommentId, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, isOffline: t1, flags: flags, isEditorExpanded: isEditorExpanded } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    let t2;
    if ($[0] !== parentComment.replies) {
        t2 = parentComment.replies.filter($b210b13432f2522a$var$_temp);
        $[0] = parentComment.replies;
        $[1] = t2;
    } else t2 = $[1];
    const allReplies = t2;
    const numOfReplies = allReplies.length;
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    let t3;
    if ($[2] !== allReplies || $[3] !== unreadCommentIDSet) {
        let t4;
        if ($[5] !== unreadCommentIDSet) {
            t4 = (r_0)=>unreadCommentIDSet.has(r_0.id);
            $[5] = unreadCommentIDSet;
            $[6] = t4;
        } else t4 = $[6];
        t3 = allReplies.filter(t4).map($b210b13432f2522a$var$_temp2);
        $[2] = allReplies;
        $[3] = unreadCommentIDSet;
        $[4] = t3;
    } else t3 = $[4];
    const unreadReplyIds = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[7] = t4;
    } else t4 = $[7];
    const [legacyVisibleReplies, setVisibleReplies] = (0, $cozmU.useState)(t4);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const commentType = parentComment.type;
    const isParentCommentOpen = parentComment.isOpen;
    const [currentReplyView, setReplyView] = (0, $cozmU.useState)((0, $ibqdE.ViewReplyOptions).ALL);
    const threadKey = commentType === (0, $8i27m.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || "" : parentCommentId;
    let t5;
    if ($[8] !== isParentCommentOpen) {
        t5 = isParentCommentOpen ? [
            "edit",
            "resolve",
            "delete"
        ] : [
            "reopen"
        ];
        $[8] = isParentCommentOpen;
        $[9] = t5;
    } else t5 = $[9];
    const supportedTopLevelActions = t5;
    const expandReplyEditor = isEditorExpanded;
    let topLevelReplyToNestedChildrenMapInternal;
    if ($[10] !== allReplies || $[11] !== parentCommentId) {
        let t6;
        if ($[13] !== parentCommentId) {
            t6 = (reply)=>reply.parentId === parentCommentId;
            $[13] = parentCommentId;
            $[14] = t6;
        } else t6 = $[14];
        const topLevelReplyIds = new Set(allReplies.filter(t6).map($b210b13432f2522a$var$_temp3));
        topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce($b210b13432f2522a$var$_temp4, {});
        const replyIdToReplyMap = allReplies.reduce($b210b13432f2522a$var$_temp5, {});
        const filteredReplies = allReplies.filter((reply_2)=>!topLevelReplyIds.has(reply_2.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId;
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        $[10] = allReplies;
        $[11] = parentCommentId;
        $[12] = topLevelReplyToNestedChildrenMapInternal;
    } else topLevelReplyToNestedChildrenMapInternal = $[12];
    const topLevelReplyToNestedChildrenMap = topLevelReplyToNestedChildrenMapInternal;
    let replies;
    if ($[15] !== allReplies || $[16] !== topLevelReplyToNestedChildrenMap) {
        replies = [];
        let t6;
        if ($[18] !== topLevelReplyToNestedChildrenMap) {
            t6 = (reply_3)=>reply_3.id in topLevelReplyToNestedChildrenMap;
            $[18] = topLevelReplyToNestedChildrenMap;
            $[19] = t6;
        } else t6 = $[19];
        const topLevelReplies = allReplies.filter(t6);
        topLevelReplies.sort($b210b13432f2522a$var$_temp6);
        for(let i = 0; i < (0, $ibqdE.DEFAULT_NUM_VISIBLE_REPLIES); i++)if (topLevelReplies.length > 0) {
            const reply_4 = topLevelReplies.pop();
            if (reply_4) replies.unshift(reply_4);
        }
        $[15] = allReplies;
        $[16] = topLevelReplyToNestedChildrenMap;
        $[17] = replies;
    } else replies = $[17];
    const latestReplies = replies;
    let latestAndNestedReplyIds;
    if ($[20] !== latestReplies || $[21] !== topLevelReplyToNestedChildrenMap) {
        latestAndNestedReplyIds = new Set();
        for (const reply_5 of latestReplies){
            latestAndNestedReplyIds.add(reply_5.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply_5.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        $[20] = latestReplies;
        $[21] = topLevelReplyToNestedChildrenMap;
        $[22] = latestAndNestedReplyIds;
    } else latestAndNestedReplyIds = $[22];
    const latestReplyIds = latestAndNestedReplyIds;
    let parentToRepliesMapInternal;
    if ($[23] !== allReplies || $[24] !== parentCommentId) {
        parentToRepliesMapInternal = {
            [parentCommentId]: [],
            ...allReplies.reduce($b210b13432f2522a$var$_temp7, {})
        };
        for (const reply_7 of allReplies)if (reply_7.parentId && reply_7.parentId in parentToRepliesMapInternal) parentToRepliesMapInternal[reply_7.parentId].push(reply_7);
        $[23] = allReplies;
        $[24] = parentCommentId;
        $[25] = parentToRepliesMapInternal;
    } else parentToRepliesMapInternal = $[25];
    const parentToRepliesMap = parentToRepliesMapInternal;
    let t6;
    if ($[26] !== allReplies || $[27] !== currentReplyView || $[28] !== isParentCommentOpen || $[29] !== latestReplies || $[30] !== parentCommentId) {
        t6 = {
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            parentCommentId: parentCommentId,
            setVisibleReplies: setVisibleReplies,
            allowNestedReplies: true
        };
        $[26] = allReplies;
        $[27] = currentReplyView;
        $[28] = isParentCommentOpen;
        $[29] = latestReplies;
        $[30] = parentCommentId;
        $[31] = t6;
    } else t6 = $[31];
    (0, $8gR6k.useUpdateVisibleReplies)(t6);
    let t7;
    if ($[32] !== allReplies || $[33] !== currentReplyView || $[34] !== isParentCommentOpen || $[35] !== latestReplies || $[36] !== parentCommentId) {
        t7 = {
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            parentCommentId: parentCommentId,
            allowNestedReplies: true
        };
        $[32] = allReplies;
        $[33] = currentReplyView;
        $[34] = isParentCommentOpen;
        $[35] = latestReplies;
        $[36] = parentCommentId;
        $[37] = t7;
    } else t7 = $[37];
    const derivedVisibleReplies = (0, $jVIRU.useVisibleReplies)(t7);
    let t8;
    if ($[38] !== derivedVisibleReplies || $[39] !== legacyVisibleReplies) {
        t8 = (0, $6mKj3.expValEquals)("confluence_fe_ssr_top_footer_comments", "isEnabled", true) ? derivedVisibleReplies : legacyVisibleReplies;
        $[38] = derivedVisibleReplies;
        $[39] = legacyVisibleReplies;
        $[40] = t8;
    } else t8 = $[40];
    const visibleReplies = t8;
    let t9;
    if ($[41] !== hasContentChanged || $[42] !== parentCommentId || $[43] !== resetContentChanged || $[44] !== setReplyToCommentId || $[45] !== showModal) {
        t9 = ()=>{
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    setReplyToCommentId({
                        parentCommentId: parentCommentId,
                        location: (0, $i6UMJ.LocationValue).FOOTER
                    });
                }
            });
            else setReplyToCommentId({
                parentCommentId: parentCommentId,
                location: (0, $i6UMJ.LocationValue).FOOTER
            });
        };
        $[41] = hasContentChanged;
        $[42] = parentCommentId;
        $[43] = resetContentChanged;
        $[44] = setReplyToCommentId;
        $[45] = showModal;
        $[46] = t9;
    } else t9 = $[46];
    const handleReplyButtonClick = t9;
    const canShowReplyButton = isParentCommentOpen && canAddComments;
    let t10;
    if ($[47] !== canShowReplyButton || $[48] !== expandReplyEditor || $[49] !== handleReplyButtonClick || $[50] !== isOffline || $[51] !== isParentCommentOpen || $[52] !== pageInfo || $[53] !== pageMode || $[54] !== parentComment || $[55] !== parentCommentId || $[56] !== threadKey) {
        t10 = ()=>expandReplyEditor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
                pageInfo: pageInfo,
                pageMode: pageMode,
                setReplyView: setReplyView,
                parentComment: parentComment,
                threadKey: threadKey,
                replyToId: parentCommentId,
                isOffline: isOffline
            }) : canShowReplyButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
                showDefaultStyles: true,
                customStyles: $b210b13432f2522a$var$replyActionButtonStyles,
                testId: "comments-panel-reply-comment-action",
                onClick: handleReplyButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                "data-cy": "comments-panel-reply-comment-action",
                appearance: "subtle",
                isDisabled: !isParentCommentOpen || isOffline,
                analyticsContext: {
                    attributes: {
                        name: "replyToCommentButton",
                        source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                    }
                },
                interactionName: "comments-panel-reply-comment-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b210b13432f2522a$var$i18n.replyAction))) : null;
        $[47] = canShowReplyButton;
        $[48] = expandReplyEditor;
        $[49] = handleReplyButtonClick;
        $[50] = isOffline;
        $[51] = isParentCommentOpen;
        $[52] = pageInfo;
        $[53] = pageMode;
        $[54] = parentComment;
        $[55] = parentCommentId;
        $[56] = threadKey;
        $[57] = t10;
    } else t10 = $[57];
    const renderFooter = t10;
    let t11;
    if ($[58] !== allReplies || $[59] !== canAddComments || $[60] !== commentType || $[61] !== currentReplyView || $[62] !== expandReplyEditor || $[63] !== handleMouseEnter || $[64] !== handleMouseLeave || $[65] !== isParentCommentOpen || $[66] !== latestReplyIds || $[67] !== parentCommentId || $[68] !== unreadReplyIds) {
        t11 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58Zuw.RepliesToggler), {
                replies: allReplies,
                unreadReplyIds: unreadReplyIds,
                setReplyView: setReplyView,
                currentReplyView: currentReplyView,
                commentType: commentType,
                parentCommentId: parentCommentId,
                canAddComments: canAddComments,
                latestReplyIds: latestReplyIds,
                isParentOpen: isParentCommentOpen,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                analyticsSource: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                expandReplyEditor: expandReplyEditor
            });
        $[58] = allReplies;
        $[59] = canAddComments;
        $[60] = commentType;
        $[61] = currentReplyView;
        $[62] = expandReplyEditor;
        $[63] = handleMouseEnter;
        $[64] = handleMouseLeave;
        $[65] = isParentCommentOpen;
        $[66] = latestReplyIds;
        $[67] = parentCommentId;
        $[68] = unreadReplyIds;
        $[69] = t11;
    } else t11 = $[69];
    const renderRepliesToggler = t11;
    const wasRemovedByAnotherUser = parentComment ? parentComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT || parentComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD : false;
    let baseStyle;
    if ($[70] !== wasRemovedByAnotherUser) {
        baseStyle = {
            display: "flex",
            flexDirection: "column",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingRight: "var(--ds-space-100, 8px)"
        };
        if (wasRemovedByAnotherUser) baseStyle.opacity = "50%";
        if ((0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) baseStyle.paddingLeft = "var(--ds-space-150, 12px)";
        $[70] = wasRemovedByAnotherUser;
        $[71] = baseStyle;
    } else baseStyle = $[71];
    const repliesBoxStyle = baseStyle;
    let t12;
    if ($[72] !== numOfReplies || $[73] !== renderRepliesToggler) {
        t12 = numOfReplies > 0 && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) && renderRepliesToggler();
        $[72] = numOfReplies;
        $[73] = renderRepliesToggler;
        $[74] = t12;
    } else t12 = $[74];
    const t13 = `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-replies`;
    let t14;
    if ($[75] !== numOfReplies || $[76] !== renderRepliesToggler) {
        t14 = numOfReplies > 0 && !(0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) && renderRepliesToggler();
        $[75] = numOfReplies;
        $[76] = renderRepliesToggler;
        $[77] = t14;
    } else t14 = $[77];
    let t15;
    if ($[78] !== canAddComments || $[79] !== canShowReplyButton || $[80] !== flags || $[81] !== handleMouseEnter || $[82] !== handleMouseLeave || $[83] !== hoveredCommentId || $[84] !== isEditorExpanded || $[85] !== isOffline || $[86] !== pageInfo || $[87] !== pageMode || $[88] !== parentComment || $[89] !== parentCommentId || $[90] !== parentToRepliesMap || $[91] !== supportedTopLevelActions || $[92] !== threadKey || $[93] !== visibleReplies.length) {
        t15 = visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $535a8f2c4921cd54$export$4c583da0a4f30f74), {
            parentReplyId: parentCommentId,
            parentToRepliesMap: parentToRepliesMap,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            canAddComments: canAddComments,
            pageInfo: pageInfo,
            pageMode: pageMode,
            threadKey: threadKey,
            supportedTopLevelActions: supportedTopLevelActions,
            hoveredCommentId: hoveredCommentId,
            isTopLevelReply: true,
            parentComment: parentComment,
            parentReplyButtonAllowed: canShowReplyButton,
            setReplyView: setReplyView,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        });
        $[78] = canAddComments;
        $[79] = canShowReplyButton;
        $[80] = flags;
        $[81] = handleMouseEnter;
        $[82] = handleMouseLeave;
        $[83] = hoveredCommentId;
        $[84] = isEditorExpanded;
        $[85] = isOffline;
        $[86] = pageInfo;
        $[87] = pageMode;
        $[88] = parentComment;
        $[89] = parentCommentId;
        $[90] = parentToRepliesMap;
        $[91] = supportedTopLevelActions;
        $[92] = threadKey;
        $[93] = visibleReplies.length;
        $[94] = t15;
    } else t15 = $[94];
    let t16;
    if ($[95] !== currentReplyView || $[96] !== handleReplyButtonClick || $[97] !== isEditorExpanded || $[98] !== isOffline || $[99] !== isParentCommentOpen || $[100] !== pageInfo || $[101] !== pageMode || $[102] !== parentComment || $[103] !== parentCommentId || $[104] !== renderFooter || $[105] !== threadKey || $[106] !== visibleReplies) {
        t16 = (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLpk8.RepliesFooter), {
            replyView: currentReplyView,
            setReplyView: setReplyView,
            isEditorExpanded: isEditorExpanded,
            isParentCommentOpen: isParentCommentOpen,
            handleReplyButtonClick: handleReplyButtonClick,
            numOfVisibleReplies: visibleReplies ? visibleReplies.length : 0,
            isOffline: isOffline,
            scrollToId: parentCommentId,
            location: (0, $i6UMJ.LocationValue).FOOTER
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
            pageInfo: pageInfo,
            pageMode: pageMode,
            setReplyView: setReplyView,
            parentComment: parentComment,
            threadKey: threadKey,
            replyToId: parentCommentId,
            isOffline: isOffline
        })) : renderFooter();
        $[95] = currentReplyView;
        $[96] = handleReplyButtonClick;
        $[97] = isEditorExpanded;
        $[98] = isOffline;
        $[99] = isParentCommentOpen;
        $[100] = pageInfo;
        $[101] = pageMode;
        $[102] = parentComment;
        $[103] = parentCommentId;
        $[104] = renderFooter;
        $[105] = threadKey;
        $[106] = visibleReplies;
        $[107] = t16;
    } else t16 = $[107];
    let t17;
    if ($[108] !== repliesBoxStyle || $[109] !== t13 || $[110] !== t14 || $[111] !== t15 || $[112] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t13,
            style: repliesBoxStyle
        }, t14, t15, t16);
        $[108] = repliesBoxStyle;
        $[109] = t13;
        $[110] = t14;
        $[111] = t15;
        $[112] = t16;
        $[113] = t17;
    } else t17 = $[113];
    let t18;
    if ($[114] !== t12 || $[115] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, t17);
        $[114] = t12;
        $[115] = t17;
        $[116] = t18;
    } else t18 = $[116];
    return t18;
};
function $b210b13432f2522a$var$_temp(r) {
    return r !== null;
}
function $b210b13432f2522a$var$_temp2(r_1) {
    return r_1.id;
}
function $b210b13432f2522a$var$_temp3(reply_0) {
    return reply_0.id;
}
function $b210b13432f2522a$var$_temp4(acc, replyId) {
    acc[replyId] = [];
    return acc;
}
function $b210b13432f2522a$var$_temp5(acc_0, reply_1) {
    acc_0[reply_1.id] = reply_1;
    return acc_0;
}
function $b210b13432f2522a$var$_temp6(a, b) {
    const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
    const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
    return dateA.getTime() - dateB.getTime();
}
function $b210b13432f2522a$var$_temp7(acc_1, reply_6) {
    return {
        ...acc_1,
        [reply_6.id]: []
    };
}


const $e368ed9f3d927a75$var$commentThreadBoxStyles = (0, $buxP3.xcss)({
    listStyle: 'none',
    position: 'relative',
    paddingLeft: 'space.200',
    paddingRight: 'space.250',
    paddingTop: 'space.100',
    // On figma this is 200 but the object comment have 100px padding on top
    paddingBottom: 'space.200',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    // Focus styles with outline - better containment
    ':focus': {
        outlineOffset: 'space.negative.025'
    },
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    }
});
const $e368ed9f3d927a75$var$newCommentThreadBoxStyles = (0, $buxP3.xcss)({
    cursor: 'pointer'
});
const $e368ed9f3d927a75$var$commentTypeSeperatorStyle = (0, $buxP3.xcss)({
    display: 'flex',
    gap: 'space.050',
    paddingTop: 'space.300',
    paddingRight: 'space.300',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $e368ed9f3d927a75$var$commentBodyBoxStyles = (0, $buxP3.xcss)({
    listStyle: 'none',
    position: 'relative',
    marginRight: 'space.100'
});
const $e368ed9f3d927a75$var$isCurrentUserSelectedCommentStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $e368ed9f3d927a75$var$isThreadPressedStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $e368ed9f3d927a75$var$i18n = (0, $kSwu1.defineMessages)({
    commentTypeSeperatorText: {
        id: "object-comments.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        id: "object-comments.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread"
    }
});
const $e368ed9f3d927a75$var$noop = ()=>{
// This is intentional
};
const $e368ed9f3d927a75$export$2ea19076574587a9 = (t0)=>{
    const $ = (0, $bDgLe.c)(64);
    const { parentComment: parentComment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, flags: flags, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, isLastThread: isLastThread, onLastThreadRendered: onLastThreadRendered, isOffline: isOffline } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t1, t2] = (0, $3mVfX.useCommentsPanel)();
    const { currentlySelectedThreadKey: currentlySelectedThreadKey, isCurrentlySelectedThreadOptimisticallyAdded: isCurrentlySelectedThreadOptimisticallyAdded } = t1;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = t2;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const threadKey = parentComment.id;
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    let t3;
    if ($[0] !== agentSessions || $[1] !== parentComment.id) {
        t3 = Boolean(agentSessions.get(parentComment.id)) && (0, $6mKj3.expValEquals)("cc_ai_agent_mention_from_comment", "isEnabled", true);
        $[0] = agentSessions;
        $[1] = parentComment.id;
        $[2] = t3;
    } else t3 = $[2];
    const parentHasAgentSession = t3;
    const [isThreadHovered, setIsThreadHovered] = (0, $cozmU.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $cozmU.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $cozmU.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $cozmU.useState)(false);
    const isEditorExpanded = (0, $7wP5b.useIsEditorExpanded)(parentComment, (0, $i6UMJ.LocationValue).FOOTER);
    const commentRef = (0, $cozmU.useRef)(null);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey || parentComment.type === (0, $8i27m.CommentType).GENERAL && !!isCurrentlySelectedThreadOptimisticallyAdded && threadKey === (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID);
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageInfo?.id ?? "", true);
    let t4;
    if ($[3] !== pageMode || $[4] !== threadKey) {
        t4 = {
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode
        };
        $[3] = pageMode;
        $[4] = threadKey;
        $[5] = t4;
    } else t4 = $[5];
    const handleCommentThreadHoverProps = t4;
    let t5;
    if ($[6] !== handleCommentThreadHoverProps) {
        t5 = (id)=>{
            (0, $cZRYC.handleCommentThreadMouseEnter)({
                ...handleCommentThreadHoverProps,
                id: id
            });
        };
        $[6] = handleCommentThreadHoverProps;
        $[7] = t5;
    } else t5 = $[7];
    const handleMouseEnter = t5;
    let t6;
    if ($[8] !== handleCommentThreadHoverProps) {
        t6 = ()=>{
            (0, $cZRYC.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
        };
        $[8] = handleCommentThreadHoverProps;
        $[9] = t6;
    } else t6 = $[9];
    const handleMouseLeave = t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (event)=>{
            event.stopPropagation();
            setCommentIsFocused(true);
        };
        $[10] = t7;
    } else t7 = $[10];
    const handleFocus = t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (event_0)=>{
            if (!event_0.relatedTarget || !event_0.currentTarget.contains(event_0.relatedTarget)) setCommentIsFocused(false);
        };
        $[11] = t8;
    } else t8 = $[11];
    const handleBlur = t8;
    let t9;
    if ($[12] !== isCurrentSelectedComment || $[13] !== setCurrentlySelectedThreadKey || $[14] !== threadKey) {
        t9 = ()=>{
            if (!isCurrentSelectedComment) {
                if (!(0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true)) setIsThreadPressed(true);
                setCurrentlySelectedThreadKey(threadKey);
            }
        };
        $[12] = isCurrentSelectedComment;
        $[13] = setCurrentlySelectedThreadKey;
        $[14] = threadKey;
        $[15] = t9;
    } else t9 = $[15];
    const handleCommentThreadMouseDown = t9;
    let t10;
    if ($[16] !== currentlySelectedThreadKey || $[17] !== isCurrentSelectedComment || $[18] !== parentComment.replies) {
        t10 = ()=>{
            if (!(0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true)) {
                const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply.id === currentlySelectedThreadKey);
                if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
                else setIsThreadPressed(false);
            }
        };
        $[16] = currentlySelectedThreadKey;
        $[17] = isCurrentSelectedComment;
        $[18] = parentComment.replies;
        $[19] = t10;
    } else t10 = $[19];
    const t11 = parentComment?.replies;
    let t12;
    if ($[20] !== currentlySelectedThreadKey || $[21] !== isCurrentSelectedComment || $[22] !== t11) {
        t12 = [
            currentlySelectedThreadKey,
            isCurrentSelectedComment,
            t11
        ];
        $[20] = currentlySelectedThreadKey;
        $[21] = isCurrentSelectedComment;
        $[22] = t11;
        $[23] = t12;
    } else t12 = $[23];
    (0, $cozmU.useEffect)(t10, t12);
    let t13;
    let t14;
    if ($[24] !== isLastThread || $[25] !== onLastThreadRendered) {
        t13 = ()=>{
            if (isLastThread && onLastThreadRendered) {
                if (typeof isLastThread === "boolean") onLastThreadRendered();
            }
        };
        t14 = [
            isLastThread,
            onLastThreadRendered
        ];
        $[24] = isLastThread;
        $[25] = onLastThreadRendered;
        $[26] = t13;
        $[27] = t14;
    } else {
        t13 = $[26];
        t14 = $[27];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    if ($[28] !== isCommentsPanelShown || $[29] !== setCurrentlySelectedThreadKey || $[30] !== threadKey) {
        t15 = ()=>{
            setCurrentlySelectedThreadKey(threadKey);
            if (isCommentsPanelShown) (0, $9FoVw.handleCommentsPanelNavigation)({
                annotationId: threadKey,
                commentType: "FOOTER",
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: "center",
                context: (0, $9FoVw.NavigationContext).PANEL
            });
        };
        $[28] = isCommentsPanelShown;
        $[29] = setCurrentlySelectedThreadKey;
        $[30] = threadKey;
        $[31] = t15;
    } else t15 = $[31];
    const objectCommentThreadHandler = t15;
    let t16;
    if ($[32] !== flags || $[33] !== isOffline || $[34] !== supportedTopLevelActions) {
        t16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
                ...props,
                supportedTopLevelActions: supportedTopLevelActions,
                flags: flags,
                isOffline: isOffline
            });
        $[32] = flags;
        $[33] = isOffline;
        $[34] = supportedTopLevelActions;
        $[35] = t16;
    } else t16 = $[35];
    const commentComponent = t16;
    let t17;
    if ($[36] !== flags || $[37] !== isOffline) {
        t17 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b210b13432f2522a$export$55de1ed49e182c87), {
                ...props_0,
                isOffline: isOffline,
                flags: flags
            });
        $[36] = flags;
        $[37] = isOffline;
        $[38] = t17;
    } else t17 = $[38];
    const commentRepliesComponent = t17;
    let t18;
    if ($[39] !== canAddComments || $[40] !== commentComponent || $[41] !== commentIsFocused || $[42] !== commentRepliesComponent || $[43] !== flags || $[44] !== formatMessage || $[45] !== handleCommentThreadMouseDown || $[46] !== handleMouseEnter || $[47] !== handleMouseLeave || $[48] !== hoveredCommentId || $[49] !== isCurrentSelectedComment || $[50] !== isEditorExpanded || $[51] !== isOffline || $[52] !== isThreadHovered || $[53] !== isThreadPressed || $[54] !== objectCommentThreadHandler || $[55] !== pageInfo || $[56] !== pageMode || $[57] !== parentComment || $[58] !== parentHasAgentSession || $[59] !== shouldRenderCommentTypeSeparator || $[60] !== supportedTopLevelActions || $[61] !== threadKey || $[62] !== unreadCommentIDSet) {
        t18 = (0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i8TeS.BaseCommentThread), {
            commentThreadRef: commentRef,
            commentComponent: commentComponent,
            commentRepliesComponent: commentRepliesComponent,
            parentComment: parentComment,
            pageMode: pageMode,
            shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator,
            canAddComments: canAddComments,
            handleCommentThreadClick: objectCommentThreadHandler,
            handleCommentThreadMouseDown: handleCommentThreadMouseDown,
            testIdPrefix: (0, $i6UMJ.LocationValue).FOOTER,
            isEditorExpanded: isEditorExpanded,
            parentHasAgentSession: parentHasAgentSession
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $e368ed9f3d927a75$var$commentTypeSeperatorStyle,
            as: "li",
            testId: "comment-section-separator",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            testId: "general-comment-page-icon",
            color: "var(--ds-icon-subtlest, #6B6E76)",
            label: formatMessage($e368ed9f3d927a75$var$i18n.commentTypeSeperatorText)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            color: "color.text.subtlest",
            weight: "medium"
        }, formatMessage($e368ed9f3d927a75$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ref: commentRef,
            id: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${threadKey}-container`,
            testId: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${threadKey}-container`,
            xcss: [
                $e368ed9f3d927a75$var$commentThreadBoxStyles,
                isCurrentSelectedComment && $e368ed9f3d927a75$var$isCurrentUserSelectedCommentStyles,
                !isCurrentSelectedComment && isThreadPressed && $e368ed9f3d927a75$var$isThreadPressedStyles,
                $e368ed9f3d927a75$var$newCommentThreadBoxStyles
            ],
            onClick: objectCommentThreadHandler,
            onMouseDown: handleCommentThreadMouseDown,
            onMouseUp: ()=>setIsThreadPressed(false),
            onFocus: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : handleFocus,
            onBlur: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : handleBlur,
            tabIndex: 0,
            "aria-label": formatMessage($e368ed9f3d927a75$var$i18n.threadContentAriaLabelWithName, {
                name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-parent`,
            xcss: $e368ed9f3d927a75$var$commentBodyBoxStyles,
            onMouseEnter: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : ()=>handleMouseEnter(parentComment.id),
            onMouseLeave: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? undefined : handleMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
            comment: parentComment,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(parentComment.id),
            isHovered: hoveredCommentId === parentComment.id || commentIsFocused,
            threadKey: threadKey,
            flags: flags,
            hideBranchingStyle: !parentHasAgentSession && ((0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? parentComment.replies.length === 0 && !isEditorExpanded : (!parentComment.isOpen || !canAddComments) && parentComment.replies.length === 0),
            canAddComments: canAddComments,
            isThreadHovered: isThreadHovered,
            isOffline: isOffline
        })), (0, $ibqdE.getShouldShowRepliesSection)({
            replies: parentComment.replies,
            isEditorExpanded: isEditorExpanded
        }) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b210b13432f2522a$export$55de1ed49e182c87), {
            parentComment: parentComment,
            pageInfo: pageInfo,
            hoveredCommentId: hoveredCommentId ?? "",
            pageMode: pageMode,
            parentCommentId: parentComment.id,
            handleMouseEnter: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? $e368ed9f3d927a75$var$noop : handleMouseEnter,
            handleMouseLeave: (0, $6mKj3.expValEquals)("confluence_frontend_fix_comment_actions_visibility", "isEnabled", true) ? $e368ed9f3d927a75$var$noop : handleMouseLeave,
            canAddComments: canAddComments,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        })));
        $[39] = canAddComments;
        $[40] = commentComponent;
        $[41] = commentIsFocused;
        $[42] = commentRepliesComponent;
        $[43] = flags;
        $[44] = formatMessage;
        $[45] = handleCommentThreadMouseDown;
        $[46] = handleMouseEnter;
        $[47] = handleMouseLeave;
        $[48] = hoveredCommentId;
        $[49] = isCurrentSelectedComment;
        $[50] = isEditorExpanded;
        $[51] = isOffline;
        $[52] = isThreadHovered;
        $[53] = isThreadPressed;
        $[54] = objectCommentThreadHandler;
        $[55] = pageInfo;
        $[56] = pageMode;
        $[57] = parentComment;
        $[58] = parentHasAgentSession;
        $[59] = shouldRenderCommentTypeSeparator;
        $[60] = supportedTopLevelActions;
        $[61] = threadKey;
        $[62] = unreadCommentIDSet;
        $[63] = t18;
    } else t18 = $[63];
    return t18;
};


const $fd40026d890a9ac0$var$listStyles = null; // this component holds a list of comments
const $fd40026d890a9ac0$export$b05be82c52775010 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { commentThreads: commentThreads, supportedTopLevelActions: supportedTopLevelActions, flags: flags, onAllCommentsRendered: onAllCommentsRendered, onCommentBatchRendered: onCommentBatchRendered, isOffline: isOffline } = t0;
    let t1;
    if ($[0] !== commentThreads) {
        t1 = (index)=>index === commentThreads.length - 1;
        $[0] = commentThreads;
        $[1] = t1;
    } else t1 = $[1];
    const isLastThread = t1;
    let t2;
    if ($[2] !== flags || $[3] !== isLastThread || $[4] !== isOffline || $[5] !== onAllCommentsRendered || $[6] !== onCommentBatchRendered || $[7] !== supportedTopLevelActions) {
        t2 = {
            supportedTopLevelActions: supportedTopLevelActions,
            flags: flags,
            onLastThreadRendered: onAllCommentsRendered,
            onCommentBatchRendered: onCommentBatchRendered,
            isLastThread: isLastThread,
            isOffline: isOffline
        };
        $[2] = flags;
        $[3] = isLastThread;
        $[4] = isOffline;
        $[5] = onAllCommentsRendered;
        $[6] = onCommentBatchRendered;
        $[7] = supportedTopLevelActions;
        $[8] = t2;
    } else t2 = $[8];
    const passThroughProps = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_18m9ewfl _1reoewfl _16jlkb7n _1e0c1ule"
        ]);
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== commentThreads || $[11] !== passThroughProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "object-comments-list-container",
            "data-testid": "object-comments-list-container",
            className: t3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3cu4A.CommentBatchList), {
            commentsList: commentThreads,
            passThroughProps: passThroughProps,
            Component: (0, $e368ed9f3d927a75$export$2ea19076574587a9),
            getElementsToBatch: (0, $7qvmT.getCommentThreadsToBatch)
        }));
        $[10] = commentThreads;
        $[11] = passThroughProps;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
};


















var $I7hWB = parcelRequire("I7hWB");


const $f06f6da515cf7544$var$commentHeaderContainerStyles = (0, $buxP3.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    background: 'color.text.inverse',
    height: '64px',
    width: '100%',
    display: 'flex',
    padding: 'space.200',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch'
});
const $f06f6da515cf7544$var$commentHeaderReactionsContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    alignSelf: 'stretch'
});
const $f06f6da515cf7544$var$i18n = (0, $kSwu1.defineMessages)({
    objectCommentHeaderText: {
        id: "object-comments.object-comment-header.text",
        defaultMessage: "Comments"
    }
});
const $f06f6da515cf7544$var$styles = {
    headerMessageStyle: "_11c81af2 _syazazsu _ect41oil _k48p1wq8"
};
const $f06f6da515cf7544$export$32c2c28e641d3a4f = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { isOffline: t1, showReactions: showReactions } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($f06f6da515cf7544$var$i18n.objectCommentHeaderText);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $f06f6da515cf7544$var$styles.headerMessageStyle
        }, t2));
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== isOffline || $[5] !== showReactions) {
        t4 = showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $f06f6da515cf7544$var$commentHeaderReactionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline
        }));
        $[4] = isOffline;
        $[5] = showReactions;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $f06f6da515cf7544$var$commentHeaderContainerStyles
        }, t3, t4);
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};


/**
 * @generated SignedSource<<f08782bd11be68dbee2d7dd2bf88a755>>
 * @relayHash 14ad450aadc2eaa7e5c6f5015481bf9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed95e9a1bb77ef5ebd80639582429151b8f7f026f79d262a10ca1ac4bba1df6d
const $c93e7e4530bd519f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ],
                            "type": "KnownUser"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v3 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v3 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedFriendlyDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolvedUser"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "resolved"
                                        }
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentEditorCreateGeneralCommentMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentEditorCreateGeneralCommentMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "14ad450aadc2eaa7e5c6f5015481bf9f",
            "id": "ed95e9a1bb77ef5ebd80639582429151b8f7f026f79d262a10ca1ac4bba1df6d",
            "metadata": {},
            "name": "ObjectAddCommentEditorCreateGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectAddCommentEditorCreateGeneralCommentMutation($cloudId:ID!,$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number}}}"
        }
    };
}();
$c93e7e4530bd519f$var$node.hash = "e80b97780580b82dc806e5ea8dc09bff";
var $c93e7e4530bd519f$export$2e2bcd8739ae039 = $c93e7e4530bd519f$var$node;















var $aGjYc = parcelRequire("aGjYc");


var $b4BfG = parcelRequire("b4BfG");





var $8Ss4E = parcelRequire("8Ss4E");


var $aJPUt = parcelRequire("aJPUt");


var $kKAQX = parcelRequire("kKAQX");

















var $56QzY = parcelRequire("56QzY");


















































var $gurMq = parcelRequire("gurMq");


var $4rKYp = parcelRequire("4rKYp");








var $dL5YQ = parcelRequire("dL5YQ");

const $2f75a8a3cc0f80c1$var$ObjectAddCommentEditorCreateGeneralCommentMutation = (0, $c93e7e4530bd519f$export$2e2bcd8739ae039);
const $2f75a8a3cc0f80c1$export$b65ed37f0eb1c56b = (0, $7aRa9.withFlags)(({ flags: flags, isOffline: isOffline, setAutoFocusPromptRef: setAutoFocusPromptRef, handleCancel: handleCancel })=>{
    const { isReactionsEnabled: isReactionsEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setAddFooterCommentAdf: setAddFooterCommentAdf } = (0, $3mVfX.useCommentsPanelActions)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    });
    const hasShownFyiRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Ref to store editor actions for focusing when sticky draft is clicked
    const editorActionsRef = (0, $cozmU.useRef)(null);
    // Focus editor when opened from sticky draft (handles case when editor is already mounted)
    (0, $cozmU.useEffect)(()=>{
        if (footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT && editorActionsRef.current?.focus) editorActionsRef.current.focus();
    }, [
        footerEditorEntry
    ]);
    const [createGeneralCommentFn] = (0, $308Wd.useMutationInterop)($2f75a8a3cc0f80c1$var$ObjectAddCommentEditorCreateGeneralCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId || '',
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const clearAddFooterCommentAdf = (0, $cozmU.useCallback)(()=>{
        setAddFooterCommentAdf(undefined);
    }, [
        setAddFooterCommentAdf
    ]);
    const failPublishExperience = (0, $cozmU.useCallback)((error)=>{
        // Mark the experience as failed/aborted and include the error details
        experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const handleCacheUpdateError = (0, $cozmU.useCallback)((error)=>{
        if ((0, $6mKj3.expValEquals)('confluence_fe_handle_use_all_comments_cache_miss', 'isEnabled', true)) flags?.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).networkError)
        });
        else failPublishExperience(error);
    }, [
        failPublishExperience,
        flags
    ]);
    const updateNewCommentInCache = (0, $cozmU.useCallback)((_dataProxy, mutationResult)=>{
        addCommentInCache({
            newComment: (0, $ag51I.addEmptyObjectRepliesAndReactions)(mutationResult.data.createFooterComment),
            onError: handleCacheUpdateError
        });
    }, [
        addCommentInCache,
        handleCacheUpdateError
    ]);
    const handleCommentsPanelSave = (adfObject, onSuccess)=>{
        const pageId = contentId || '';
        const { adf: adf } = adfObject;
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
        });
        const mutationVariables = {
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $kKAQX.ContentRepresentation).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $kKAQX.Platform).WEB,
                containerId: pageId
            }
        };
        const isOptimisticAddEnabled = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)('page', 'create');
        const optimisticResponse = isOptimisticAddEnabled ? (0, $ag51I.getOptimisticResponse)({
            userId: userId ?? '',
            displayName: displayName ?? '',
            adf: adf,
            pageId: pageId,
            parentCommentId: null
        }) : undefined;
        const optimisticCommentId = optimisticResponse?.createFooterComment?.id;
        if (isOptimisticAddEnabled) {
            onSuccess && onSuccess();
            clearAddFooterCommentAdf();
            closeCommentContainer();
            // set the new comment as selected and scroll to it
            optimisticCommentId && setCurrentlySelectedThreadKey(optimisticCommentId, (0, $8i27m.CommentType).GENERAL);
            optimisticCommentId && (0, $9FoVw.handleFooterCommentsNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                inline: 'center',
                commentId: optimisticCommentId
            });
        }
        const mutationPromise = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? createObjectCommentMutationFn({
            variables: {
                ...mutationVariables,
                pageId: pageId,
                includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
            },
            // @ts-ignore -- can't import type directly in update FN because it'd be circular
            update: updateNewCommentInCache,
            optimisticResponse: optimisticResponse
        }) : createGeneralCommentFn({
            variables: mutationVariables,
            // @ts-ignore -- can't import type directly in update FN because it'd be circular
            update: (0, $87CZC.updateApolloCacheParentCallback)('create', {
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ],
                type: [
                    'FOOTER'
                ]
            }, isReactionsEnabled)
        });
        return mutationPromise.then(({ data: data })=>{
            const commentResult = data.createFooterComment;
            const comment = {
                ...commentResult,
                replies: [],
                // not included in the payload
                isOpen: true,
                type: (0, $8i27m.CommentType).GENERAL
            };
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads({
                inline: {},
                general: {
                    [comment.id]: comment
                }
            });
            if (!isOptimisticAddEnabled) {
                onSuccess && onSuccess(); // This is CommentEditor's `resetEditor` callback.
                clearAddFooterCommentAdf();
                closeCommentContainer();
            }
            resetContentChanged();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: comment.id,
                    // The newly created comment ID
                    objectType: contentType,
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    attributes: {
                        commentType: (0, $en1dX.CommentType).PAGE,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        pageMode: pageMode,
                        isReply: false,
                        pageType: contentType,
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        editor: 'v2',
                        searchSessionId: searchSessionId,
                        navdexPointType: (0, $56QzY.END),
                        parentCommentId: null,
                        // analytics event schema type expects string or null
                        isStickyFooter: footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT // Keeps track of where the actual create came from
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            if (!isOptimisticAddEnabled) {
                // set the new comment as selected and scroll to it - already done if optimistic add is enabled
                setCurrentlySelectedThreadKey(comment.id, (0, $8i27m.CommentType).GENERAL);
                (0, $9FoVw.handleFooterCommentsNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    block: 'center',
                    inline: 'center',
                    commentId: comment.id
                });
            } else // set the new comment as selected with its actual id
            setCurrentlySelectedThreadKey(comment.id, (0, $8i27m.CommentType).GENERAL, true);
            // Return the new comment ID so downstream consumers (e.g. PageCommentEditor)
            // can pass it to handleAgentMentionInComment without needing to re-fetch it.
            return {
                id: comment.id
            };
        }).catch((error)=>{
            const translatedError = (0, $lFkRf.getTranslatedError)(error);
            const isAbortableError = (0, $lFkRf.isCommentAbortableError)(translatedError, (0, $9wGTI.fg)('confluence_comments_abort_on_container_not_found'));
            if (isAbortableError) {
                // TODO: show an error message to the user for create not permitted
                experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                    reason: translatedError.id
                });
                // Abort parent experience too, since it's not automatically aborted when child is aborted.
                experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    reason: translatedError.id
                });
            } else failPublishExperience(error);
            if ((0, $9wGTI.fg)('confluence_comments_error_handling_improvements')) return Promise.reject({
                error: translatedError
            });
        });
    };
    const handleCancelInternal = ({ isEditorAborted: isEditorAborted })=>{
        const doCancel = ()=>{
            if (isEditorAborted) {
                setAutoFocusPromptRef?.(true);
                experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    reason: 'aborted because comment was cancelled'
                });
            }
            clearAddFooterCommentAdf();
            closeCommentContainer();
            handleCancel?.();
        };
        if (hasContentChanged) resetContentChanged();
        doCancel();
    };
    const handleOnEditorLoaded = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
        });
        const footerCommentContainer = renderServerPlaceholder || typeof document === 'undefined' ? null : document.querySelector('[data-testId="footerCommentEditor"]');
        if (!footerCommentContainer) return;
        footerCommentContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    };
    const handleEditorReady = (editorActions)=>{
        handleOnEditorLoaded();
        // Store editor actions for later use (e.g., focusing from sticky draft)
        editorActionsRef.current = editorActions;
        // Focus the editor when opened from sticky draft
        if (footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT && editorActions?.focus) editorActions.focus();
    };
    // This is debounced at the editor level (at 150ms) to prevent constant updates hurting performance
    const handleEditorContentChangedWithData = (hasContent, content)=>{
        // Store the actual ADF content for real-time sync
        if (hasContent && content) setAddFooterCommentAdf(content);
        else setAddFooterCommentAdf(undefined);
        // Also call the original onChange handler
        onChange(hasContent);
        onAgentMentionContentChange(content);
    };
    const agentMentionFyiNudge = (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
        visible: showFyi,
        agent: agent
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), {
        banner: agentMentionFyiNudge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4BfG.PageCommentEditor), {
        mode: "create",
        saveHandler: handleCommentsPanelSave,
        cancelHandler: handleCancelInternal,
        onEditorLoaded: handleOnEditorLoaded,
        onEditorReady: handleEditorReady,
        onEditorContentChangedWithData: handleEditorContentChangedWithData,
        useNewExperienceAbort: true,
        expandEditor: true,
        isFooterComment: true,
        isOffline: isOffline,
        showAgentMentionFyiNudge: false
    }));
});



var $MJaSd = parcelRequire("MJaSd");

// GraphQL query for preloading first 3 footer comments
// NOTE: If you update the return type of this query, you need to update the type
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
const $0606d9a810dabf91$var$ObjectCommentContainerPreloadObjectCommentsQuery = (0, $1ydBT.default);
const $0606d9a810dabf91$var$commentPanelContainerStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: '100%',
    width: '100%'
});
const $0606d9a810dabf91$var$wrapperStyle = (0, $buxP3.xcss)({
    position: 'relative',
    visibility: 'visible',
    minHeight: '50px',
    margin: '0 auto'
});
const $0606d9a810dabf91$var$baseEditorStyles = (0, $buxP3.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200',
    position: 'relative'
});
const $0606d9a810dabf91$var$footerStickyWrapperStyle = (0, $buxP3.xcss)({
    zIndex: 'navigation',
    backgroundColor: 'elevation.surface',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 'space.0'
});
const $0606d9a810dabf91$var$viewPageFooterStyle = (0, $buxP3.xcss)({
    zIndex: '1',
    transform: 'unset',
    bottom: 'space.0'
});
const $0606d9a810dabf91$var$footerEditorStyle = (0, $buxP3.xcss)({
    left: 'space.0'
});
const $0606d9a810dabf91$var$fixedEditorStyles = (0, $buxP3.xcss)({
    position: 'fixed'
});
const $0606d9a810dabf91$var$stickyEditorStyles = (0, $buxP3.xcss)({
    position: 'sticky'
});
const $0606d9a810dabf91$var$placeholderStyle = (0, $buxP3.xcss)({
    width: '60%'
});
const $0606d9a810dabf91$var$incrementalLoadingPlaceholderStyle = (0, $buxP3.xcss)({
    width: '60%'
});
const $0606d9a810dabf91$var$addCommentContainerStyles = (0, $buxP3.xcss)({
    transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
    transformOrigin: 'top',
    position: 'sticky',
    bottom: 'space.0',
    zIndex: '1' // Required for create comment editor overflow to show on top of page content
});
const $0606d9a810dabf91$var$addCommentContainerAnimationHiddenStyles = (0, $buxP3.xcss)({
    transform: 'translateY(100%)',
    opacity: '0',
    pointerEvents: 'none'
});
const $0606d9a810dabf91$var$addCommentContainerAnimationShowStyles = (0, $buxP3.xcss)({
    transform: 'translateY(0)',
    opacity: '1',
    pointerEvents: 'auto'
});
const $0606d9a810dabf91$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $0606d9a810dabf91$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $0606d9a810dabf91$var$ObjectCommentContainerComponent = (0, $7aRa9.withFlags)(({ flags: flags, pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline, hasCommentSessions: hasCommentSessions })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    // The footer mounts AgentSessionsFetcher only when the page-load `cc-agent-mention-sessions`
    // marker says sessions exist (hasCommentSessions, derived from ContentUnifiedQuery). But when
    // an agent is @-mentioned in a comment THIS session, the marker write (REST) isn't reflected
    // in the already-cached ContentUnifiedQuery, so hasCommentSessions stays false until a reload
    // and the footer never shows the new session. Optimistically flip this flag on the
    // comment-saved event so the fetcher mounts and its post-save poll surfaces the session
    // without a reload. (Panel/inline don't need this — they mount AgentSessionsProvider eagerly.)
    const [agentMentionedThisSession, setAgentMentionedThisSession] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        // Kill-switch: when the experiment is off, don't even register the listener — keep this
        // feature's production side effects fully gated, like the rest of it. The effect is still
        // called unconditionally (Rules of Hooks); only its body is guarded. expValEquals is
        // stable for the session, so reading it once on mount with empty deps is correct.
        if (!(0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) return;
        const handleAgentMentionCommentSaved = ()=>setAgentMentionedThisSession(true);
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionCommentSaved);
        return ()=>window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionCommentSaved);
    }, []);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [commentSectionTop, setCommentSectionTop] = (0, $cozmU.useState)(0);
    const [isInViewport, setIsInViewport] = (0, $cozmU.useState)(false);
    const [allCommentsRendered, setAllCommentsRendered] = (0, $cozmU.useState)(false);
    const [commentBatchRendered, setCommentBatchRendered] = (0, $cozmU.useState)(false);
    const [commentBatchCount, setCommentBatchCount] = (0, $cozmU.useState)(0);
    const [forceLoadComments, setForceLoadComments] = (0, $cozmU.useState)(false);
    const [shouldShowAddComment, setShouldShowAddComment] = (0, $cozmU.useState)(true);
    const [state] = (0, $isEtk.useContentState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isServer = (0, $e4o8D.useRenderServerPlaceholder)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const { expanded: expanded, width: width, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    // Hide OmniBar when the footer comment component is open (e.g. Comment button clicked)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (expanded) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        expanded,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    // Track page-content-only dimensions for layout alignment and blue background sizing
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, footerCommentsLoadingState: footerCommentsLoadingState } = (0, $8i27m.useCommentsDataState)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Read preload data from cache synchronously
    // Query for all content statuses, filtering happens after the fact
    let preloadCacheData = null;
    if (contentId && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) try {
        preloadCacheData = (0, $l1uFv.readQueryInterop)({
            query: $0606d9a810dabf91$var$ObjectCommentContainerPreloadObjectCommentsQuery,
            variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId),
            __callerPackage__: "object-comments"
        });
    } catch  {
        // Query not in cache yet, that's fine
        preloadCacheData = null;
    }
    const preloadAwareFooterDataResult = (0, $cozmU.useMemo)(()=>(0, $MJaSd.getPreloadAwareObjectComments)(processedCommentsData, preloadCacheData, contentStatusFilters), [
        processedCommentsData,
        preloadCacheData,
        contentStatusFilters
    ]);
    const [shouldRequeryArchivedComments, setShouldRequeryArchivedComments] = (0, $cozmU.useState)(false);
    const hasRequeriedArchivedComments = (0, $cozmU.useRef)(false);
    const startedExperience = (0, $cozmU.useRef)(false);
    const focusedCommentId = $0606d9a810dabf91$var$useFocusedCommentIdQueryParam();
    const replyToComment = $0606d9a810dabf91$var$useReplyToCommentQueryParam();
    const { replyToCommentId: replyToCommentId, commentType: commentType, currentlySelectedThreadKey: currentlySelectedThreadKey, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    const [{ isUnreadQueryLoading: isUnreadQueryLoading }] = (0, $fHAwL.useUnreadComments)();
    const [hasLoadedUnreadStatus, setHasLoadedUnreadStatus] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isContentReady = pageMode === (0, $cD1qu.PageMode).VIEW ? state.isContentReady : true;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Hide add comment container on archived pages
    (0, $cozmU.useEffect)(()=>{
        if (isArchived) {
            setShouldShowAddComment(false);
            setShouldRequeryArchivedComments(true);
        }
    }, [
        isArchived
    ]);
    // Close comment container when expanded and contentId changes
    (0, $cozmU.useEffect)(()=>{
        if (expanded && contentId) closeCommentContainer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // AKA - has the user scrolled to the bottom of the page?
    const isContentInViewport = isInViewport && isContentReady;
    // Query setup - skip if not forcing load and not in viewport and not loaded yet
    const commentsQueryHook = (0, $dkkKv.useActiveCommentsQuery);
    // When preloading, we don't always have access to archived page state (depends on a race condition for cache hit / miss)
    // In those cases, we can incorrectly determine that the page is fully loaded with no comments, when really we just queried using the wrong vars
    // Given that archived are such a small percent of loads, just force a reload here (i.e. don't trust cache) to be safe
    const shouldForceReloadForArchivedComments = shouldRequeryArchivedComments && !hasRequeriedArchivedComments.current;
    const wasFullyLoaded = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isUsingFullData || preloadAwareFooterDataResult.allDataPreloaded : footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).FULLY_LOADED && !shouldForceReloadForArchivedComments;
    const wasPartiallyPreloaded = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isPreloadDataProcessed : footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED;
    const isPreloading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isPreloadLoading : footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).PRELOADING;
    const shouldLoadFromNetwork = !wasFullyLoaded && !isPreloading && (isContentInViewport || forceLoadComments);
    const commentsQueryHookVariables = {
        pageId: contentId || '',
        skip: wasFullyLoaded || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        // Skip once we have all data - essentially, we don't need to subscribe to apollo updates after this point since we get everything from sweet state
        type: 'FOOTER',
        returnNativeLoading: true,
        // required for `loading` to behave as expected
        useStableCommentsDataUpdates: true,
        fetchPolicy: shouldLoadFromNetwork ? 'network-only' : 'cache-only',
        isPreload: isServer
    };
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const legacyQueryResult = commentsQueryHook(commentsQueryHookVariables);
    // Use new or legacy data based on experiment
    const { error: error, data: data } = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? {
        data: {
            comments: {
                totalCount: preloadAwareFooterDataResult.commentCount,
                nodes: preloadAwareFooterDataResult.openFooterComments
            }
        },
        error: preloadAwareFooterDataResult.error
    } : legacyQueryResult;
    // Enhanced loading state that accounts for new data manager processing
    // When using new data manager, only show loading if we're actually loading OR if data isn't processed yet
    const loading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.isPreloadLoading || !preloadAwareFooterDataResult.isDataProcessed : legacyQueryResult.loading;
    // In cases where the first paint will be correct (i.e. will match SPA version because nothing controlled by a useEffect / DOM action), immediately render
    // Otherwise, this will just happen on first paint in SPA once the useEffects run
    const renderOnServer = isServer && data?.comments?.totalCount === 0;
    const noOpenObjectComments = (0, $cozmU.useMemo)(()=>{
        return data?.comments?.nodes?.length === 0 || true;
    }, [
        data
    ]);
    // If we're forcing a reload for archived comments, we need to set the flag to true so we don't try to reload again
    (0, $cozmU.useEffect)(()=>{
        if (shouldForceReloadForArchivedComments && !loading && data) hasRequeriedArchivedComments.current = true;
    }, [
        data,
        loading,
        shouldForceReloadForArchivedComments
    ]);
    // AKA - are we done loading?
    const shouldShowComments = wasFullyLoaded || wasPartiallyPreloaded || renderOnServer;
    // Return null when we haven't loaded anything yet, we're not in the viewport, and we're not SSRed
    const shouldReturnNull = error && !(0, $i6UMJ.onlyHasReactionsSummaryErrors)(error) || !isContentInViewport && !shouldShowComments;
    // Show global placeholder (i.e. instead of comments header, etc) when we're in the viewport but are still loading, and we're not SSRed
    const shouldShowGlobalPlaceholder = isContentInViewport && !shouldShowComments;
    // Show incremental loading placeholder in SSR when preload is completed with comments
    // We can't show the comments themselves because commentThreads is set across multiple renders via sweet state
    // This also ensures that we either show the loading placeholder or the comment threads, never both
    // Without it, we can briefly show both threads & the placeholder, even if fully loaded
    // UPDATE: SSRing the incremental loading placeholder seems to slow down rendering of the
    // preloaded top footer comments on browser, leading to an increase in ViewPage VC90. Thus,
    // `confluence_fe_ssr_top_footer_comments` experiment disables it and instead renders the
    // actual top footer comments on server-side.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    const shouldShowIncrementalLoadingPlaceholderOnServer = isServer && preloadAwareFooterDataResult?.preloadCompletedWithComments && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && !(0, $6mKj3.expValEquals)('confluence_fe_ssr_top_footer_comments', 'isEnabled', true);
    // Show placeholder when we're in the viewport but are still loading the rest of the data
    const shouldShowIncrementalLoadingPlaceholder = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? shouldShowComments && loading && !wasFullyLoaded || shouldShowIncrementalLoadingPlaceholderOnServer : shouldShowComments && loading;
    // Set up IntersectionObserver
    (0, $cozmU.useEffect)(()=>{
        if (isServer || !isContentReady) // Don't register observer if page content is not ready
        return;
        // eslint-disable-next-line no-restricted-syntax
        const observer = new IntersectionObserver(([entry])=>{
            const isIntersecting = entry.isIntersecting;
            if (isIntersecting) setIsInViewport(isIntersecting);
        }, {
            root: null,
            rootMargin: '10px',
            threshold: 0.1
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isServer,
        pageMode,
        state.isContentReady,
        isContentReady
    ]);
    // Add MutationObserver to detect when comments are actually rendered --- old logic for checking all comment rendered or not
    (0, $cozmU.useEffect)(()=>{
        if (isServer || !currentlySelectedThreadKey) return;
        const observer = new MutationObserver(()=>{
            const commentElementId = `footer-comment-thread-${currentlySelectedThreadKey}-container`;
            const commentElement = document.getElementById(commentElementId);
            if (commentElement) {
                setAllCommentsRendered(true);
                observer.disconnect(); // Disconnect once we find the element
            } else setAllCommentsRendered(false); // Reset if element not found
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Reset allCommentsRendered when unmounting or changing thread key
        return ()=>{
            setAllCommentsRendered(false);
            observer.disconnect();
        };
    }, [
        currentlySelectedThreadKey,
        isServer
    ]);
    // Update loaded state when data is received
    (0, $cozmU.useEffect)(()=>{
        if (wasFullyLoaded) setForceLoadComments(false);
    }, [
        wasFullyLoaded
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isUnreadQueryLoading && !hasLoadedUnreadStatus) setHasLoadedUnreadStatus(true);
    }, [
        isUnreadQueryLoading,
        hasLoadedUnreadStatus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (commentType === (0, $8i27m.CommentType).GENERAL) {
            const commentElementId = `footer-comment-thread-${currentlySelectedThreadKey}-container`;
            const isCommentExists = document.getElementById(commentElementId);
            if (!isCommentExists) setForceLoadComments(true);
        }
    }, [
        currentlySelectedThreadKey,
        commentType
    ]);
    // Handle spacing for Editor & LiveDoc modes by observing the size of editorTextArea
    (0, $cozmU.useEffect)(()=>{
        const editorTextArea = document.getElementById('ak-editor-textarea');
        if (editorTextArea) {
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            hasRecs && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
                setCommentSectionTop(0);
                return;
            }
            const resizeObserver = new ResizeObserver((entries)=>{
                const newTop = (0, $aHcFH.getCommentPositionTopOfSectionEditor)(entries);
                (0, $9kbTQ.flushSync)(()=>{
                    newTop !== undefined && setCommentSectionTop(newTop);
                });
            });
            // observe resize of editorTextArea to update spacing when content changes
            resizeObserver.observe(editorTextArea);
            // observe resize of document.body to update spacing when window height changes
            resizeObserver.observe(document.body);
            return ()=>resizeObserver.disconnect();
        }
    }, [
        hasRecs
    ]);
    // Handle spacing for Renderer mode based on content and window height
    (0, $cozmU.useEffect)(()=>{
        const renderContentContainer = document.querySelector('[data-testid="content-container-component"]');
        if (pageMode === (0, $cD1qu.PageMode).VIEW && renderContentContainer && (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_old')) {
            const resizeObserver = new ResizeObserver((_entries)=>{
                const newTop = (0, $aHcFH.getCommentPositionTopOfSectionRenderer)();
                (0, $9kbTQ.flushSync)(()=>{
                    setCommentSectionTop(newTop);
                });
            });
            // observe resize of content-container-component to update spacing when content changes
            // (the container includes page title, content, and end-of-page recommendations components, etc.)
            resizeObserver.observe(renderContentContainer);
            // observe resize of document.body to update spacing when window height changes
            resizeObserver.observe(document.body);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        pageMode
    ]);
    // Create commentsDataMap from new data when experiment is enabled
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? preloadAwareFooterDataResult.commentsDataMap : legacyCommentsDataMap;
    const commentThreads = (0, $cozmU.useMemo)(()=>{
        if (!wasFullyLoaded && !shouldShowComments) // no need to update if we haven't loaded, or aren't showing comments
        return [];
        return (0, $6lAIr.getVisibleCommentThreads)({
            commentsDataMap: commentsDataMap,
            includeGeneralComments: true,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        });
    }, [
        wasFullyLoaded,
        shouldShowComments,
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode
    ]);
    const hasComments = commentThreads.length > 0;
    // Handle add comment container animation and mounting
    (0, $cozmU.useEffect)(()=>{
        if (isArchived) return;
        const shouldHide = !!replyToCommentId && commentLocation === (0, $i6UMJ.LocationValue).FOOTER;
        if (shouldHide) // Start hiding animation
        setShouldShowAddComment(false);
        else {
            // Show component after a small delay to allow for animation
            const timer = setTimeout(()=>{
                setShouldShowAddComment(true);
            }, 50);
            return ()=>clearTimeout(timer);
        }
    }, [
        replyToCommentId,
        commentLocation,
        isArchived
    ]);
    // Track the start of comments loading and initialize performance metrics
    (0, $cozmU.useEffect)(()=>{
        const shouldStartExperience = !startedExperience.current && (isContentInViewport && loading || wasFullyLoaded && hasComments);
        if (shouldStartExperience) {
            // Start tracking the page comments experience with initial attributes
            experienceTracker.start({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    isConditionalRenderingOn: true,
                    isFocusedComment: Boolean(focusedCommentId || replyToComment),
                    contentId: contentId,
                    pageMode: pageMode
                }
            });
            startedExperience.current = true;
            // Initialize and mark the start of page comments rendering metrics
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).start();
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).mark('pageCommentsRenderStart');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldShowIncrementalLoadingPlaceholder,
        shouldShowGlobalPlaceholder,
        loading,
        isContentInViewport,
        wasFullyLoaded,
        hasComments
    ]);
    // Track any errors that occur during comments loading
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if ((0, $i6UMJ.onlyHasReactionsSummaryErrors)(error)) {
                experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                    attributes: {
                        ignoredReactionsSummaryErrors: true
                    }
                });
                // Comments may still be displayed without reactions, so do not
                // fail or abort the experience but just return here.
                return;
            }
            const translatedError = (0, $lFkRf.getTranslatedError)(error);
            if ((0, $lFkRf.isViewNotPermittedError)(translatedError)) {
                // If the error is a 403 permission error, show a warning flag and abort the experience
                flags.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                    reason: (0, $FBfum.i18n).viewNotPermitted.id
                });
                (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).cancel();
                return;
            }
            if ((0, $lFkRf.isNetworkError)(translatedError)) // Show flag for network error
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
            });
            // Mark the experience as failed/aborted and include the error details
            experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                error: error
            });
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error
    ]);
    // Track successful completion of comments rendering
    (0, $cozmU.useEffect)(()=>{
        if (allCommentsRendered && wasFullyLoaded && hasComments) {
            // Mark the experience as successful and include total comments count
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    totalComments: data?.comments?.totalCount,
                    totalCommentThreads: commentThreads.length
                }
            });
            // Mark key performance metrics:
            // - pageCommentsRenderEnd: End of comments rendering
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).mark('pageCommentsRenderEnd');
            // Stop the metric tracking and include final data
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).stop({
                customData: {
                    contentId: contentId || '',
                    totalComments: data?.comments?.totalCount || 0
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allCommentsRendered,
        wasFullyLoaded,
        hasComments
    ]);
    // Track successful completion of first comment batch rendering
    (0, $cozmU.useEffect)(()=>{
        if (commentBatchRendered) {
            // Mark key performance metrics:
            // - fmp: First Meaningful Paint
            // - tti: Time to Interactive
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).markFMP();
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).mark('tti');
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE));
            if (experienceState?.startTime && typeof experienceState.startTime === 'number') experienceTracker.updateAttributes({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    firstMeaningfulPaint: window.performance.now() - experienceState.startTime
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentBatchRendered
    ]);
    // Handle case when there are no comments to render
    (0, $cozmU.useEffect)(()=>{
        if (data?.comments?.totalCount === 0) {
            // Abort the experience tracking since there are no comments to render
            experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                reason: 'No page comments'
            });
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    const handleAllCommentsRendered = (0, $cozmU.useCallback)(()=>setAllCommentsRendered(true), []);
    const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
        pageMode: pageMode,
        pageWidthType: pageWidthType,
        hasEndOfPageRecommendations: hasRecs ?? false
    });
    const shouldRenderFixedStyle = (0, $cozmU.useMemo)(()=>{
        if (expanded && footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT) return true;
        return false;
    }, [
        expanded,
        footerEditorEntry
    ]);
    const pageContentDimensions = (0, $cozmU.useMemo)(()=>({
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        }), [
        pageContentWidth,
        pageContentLeft,
        pageContentRight
    ]);
    // AgentSessionsFetcher is only mounted when the experiment is on — this guarantees
    // zero Relay queries and zero Suspense when the gate is off.
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: wrapperRef,
        xcss: $0606d9a810dabf91$var$wrapperStyle,
        testId: "object-comment-wrapper",
        style: {
            top: commentSectionTop,
            width: computedWidths.width,
            maxWidth: computedWidths.maxWidth
        },
        "data-vc": `object-comment-wrapper-${pageMode}-${hasComments ? 'has-comments' : 'no-comments'}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90365d58d6587547$export$1e65952d87b47593), {
        hasLoadedObjectComments: !!shouldShowComments,
        allObjectCommentsRendered: allCommentsRendered || noOpenObjectComments || wasFullyLoaded,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        setForceLoadComments: setForceLoadComments
    }), shouldReturnNull ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldShowGlobalPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$placeholderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c27f350b69a05b43$export$46096a93b7c122b2), {
        showPlaceholder: true
    })), shouldShowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId ?? ''
    }, hasComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f06f6da515cf7544$export$32c2c28e641d3a4f), {
        isOffline: editorIsUserOffline,
        showReactions: isEmbeddedConfluence ? hasReactions : true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $0606d9a810dabf91$var$commentPanelContainerStyles
    }, !shouldShowIncrementalLoadingPlaceholderOnServer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd40026d890a9ac0$export$b05be82c52775010), {
        commentThreads: commentThreads,
        supportedTopLevelActions: [
            'edit',
            'resolve',
            'delete'
        ],
        flags: flags,
        onAllCommentsRendered: handleAllCommentsRendered,
        onCommentBatchRendered: ()=>{
            setCommentBatchRendered(true);
            setCommentBatchCount((prev)=>prev + 1);
        },
        isOffline: editorIsUserOffline
    }), shouldShowIncrementalLoadingPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$incrementalLoadingPlaceholderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c27f350b69a05b43$export$46096a93b7c122b2), {
        showPlaceholder: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $0606d9a810dabf91$var$addCommentContainerStyles,
            !!replyToCommentId && commentLocation === (0, $i6UMJ.LocationValue).FOOTER ? $0606d9a810dabf91$var$addCommentContainerAnimationHiddenStyles : $0606d9a810dabf91$var$addCommentContainerAnimationShowStyles
        ]
    }, !shouldShowGlobalPlaceholder && !shouldShowIncrementalLoadingPlaceholder && shouldShowAddComment && !isArchived && !expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2998c7377d5266d6$export$f3a35a1c0e5d2996), {
        showReactions: !hasComments && (isEmbeddedConfluence ? hasReactions : true),
        showLabels: showLabels,
        isOffline: editorIsUserOffline,
        optimisticReactions: true
    }))))), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $0606d9a810dabf91$var$footerStickyWrapperStyle,
            shouldRenderFixedStyle ? $0606d9a810dabf91$var$fixedEditorStyles : $0606d9a810dabf91$var$stickyEditorStyles,
            pageMode === (0, $cD1qu.PageMode).VIEW && $0606d9a810dabf91$var$viewPageFooterStyle,
            pageMode !== (0, $cD1qu.PageMode).VIEW && $0606d9a810dabf91$var$footerEditorStyle
        ],
        testId: "footerCommentEditor",
        style: pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: shouldRenderFixedStyle,
            pageContentDimensions: pageContentDimensions,
            fallbackWidth: width
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$baseEditorStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            width: width,
            maxWidth: computedWidths.maxWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f75a8a3cc0f80c1$export$b65ed37f0eb1c56b), {
        isOffline: editorIsUserOffline
    }))));
    // Mount the fetcher when the page-load marker says there are sessions OR an agent was
    // mentioned this session (the marker isn't yet reflected in the cached ContentUnifiedQuery).
    // hasCommentSessions already includes the experiment gate; gate the optimistic branch on the
    // experiment too so it stays a kill-switch. Ordered last per confluence-feature-gating rules.
    if (hasCommentSessions || agentMentionedThisSession && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) {
        const mountedFromLocalMention = agentMentionedThisSession && !hasCommentSessions;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac96fb5095c0413f$export$4d8c455866c22554), {
            pageId: contentId ?? '',
            refetchOnMount: mountedFromLocalMention,
            preserveEmptyMarker: mountedFromLocalMention
        }, content);
    }
    return content;
});
const $0606d9a810dabf91$export$82b49dda6ae20eb7 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})($0606d9a810dabf91$var$ObjectCommentContainerComponent);
module.exports["ObjectCommentContainer"] = $0606d9a810dabf91$export$82b49dda6ae20eb7;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<2677448ae3824ed4f96e28a9f90ebc11>>
 * @relayHash cba455fca3d3e3ded9f59ef8dd1da82e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b15555a02e345dcac49028e56ae8de642103a954aa49f5dd68c34c48c3bc41c1
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "cba455fca3d3e3ded9f59ef8dd1da82e",
            "id": "b15555a02e345dcac49028e56ae8de642103a954aa49f5dd68c34c48c3bc41c1",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "3a2732629f8a4a69bf446268336b7bc9";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("famWw", function(module, exports) {
/* AddCommentPromptButton.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $cY2bA = parcelRequire("cY2bA");


var $hBYtq = parcelRequire("hBYtq");


var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");

const $6aab88ace7ca0350$var$styles = {
    addCommentButtonStyle: "_1yt4ze3t _2rko12b0 _11c8fhey _1e0c1txw _1tkezwfg _19bvutpp _u5f3utpp _1bah1h6o _4cvr1h6o _syazazsu",
    enabledStyle: "_bfhksm61 _d0altlke _irr31dpa",
    disabledStyle: "_bfhk187o _80om13gf _syaz1gmx",
    fullWidthStyle: "_1bsb1osq"
};
const $6aab88ace7ca0350$var$i18n = (0, $kSwu1.defineMessages)({
    addCommentPromptText: {
        id: "comments-common.add-comment-prompt.text",
        defaultMessage: "Add a comment"
    },
    addCommentPromptAriaLabel: {
        id: "comments-common.add-comment-prompt.aria-label",
        defaultMessage: "Add a general comment"
    }
});
const $6aab88ace7ca0350$export$caf1bbdc1c7b1a40 = ({ onClick: onClick, autofocusRef: autofocusRef, shouldFitContainer: shouldFitContainer, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId || '');
    const buttonRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (autofocusRef.current) {
            buttonRef.current?.focus({
                preventScroll: true
            });
            autofocusRef.current = false;
        }
    }, [
        autofocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($6aab88ace7ca0350$var$styles.addCommentButtonStyle, !canAddComments ? $6aab88ace7ca0350$var$styles.disabledStyle : $6aab88ace7ca0350$var$styles.enabledStyle, shouldFitContainer && $6aab88ace7ca0350$var$styles.fullWidthStyle),
        isDisabled: !canAddComments,
        onClick: onClick,
        testId: testId,
        ref: buttonRef,
        "aria-label": formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptAriaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cY2bA))), {
        label: formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText))));
};
module.exports["AddCommentPromptButton"] = $6aab88ace7ca0350$export$caf1bbdc1c7b1a40;

});

parcelRegister("l3kuI", function(module, exports) {

let $f539c68e994d9320$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f539c68e994d9320$var$load("BbB4M").then(()=>parcelRequire('JSoWM'));

});

parcelRegister("3cu4A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $8i27m = parcelRequire("8i27m");


var $6eYRP = parcelRequire("6eYRP");

const $ba24a8cc7b954968$export$3577ba943a5537ec = 8;
// Binary search to find the transition point between inline/general comments
const $ba24a8cc7b954968$var$findTransitionIndex = (commentsList)=>{
    if (!commentsList.length) return 0;
    let low = 0;
    let high = commentsList.length - 1;
    // If all comments are of the same type, return 0
    const firstType = commentsList[0].type;
    const lastType = commentsList[high].type;
    if (firstType === lastType) return 0;
    while(low < high){
        const mid = Math.floor((low + high) / 2);
        if (commentsList[mid].type === (0, $8i27m.CommentType).INLINE) low = mid + 1;
        else high = mid;
    }
    return low;
};
const $ba24a8cc7b954968$var$CommentBatchListInner = ({ commentsList: commentsList, passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const batchCount = Math.ceil(commentsList.length / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const batches = (0, $cozmU.useMemo)(()=>new Array(batchCount).fill(0), [
        batchCount
    ]);
    const [batch, setBatch] = (0, $cozmU.useState)(0);
    const onBatchRendered = (0, $cozmU.useCallback)((batchIndex)=>{
        if (passThroughProps) {
            passThroughProps.onCommentBatchRendered && passThroughProps.onCommentBatchRendered();
            if (batches.length && batchIndex === batches.length - 1) passThroughProps.onLastThreadRendered && passThroughProps.onLastThreadRendered();
        }
        setBatch(batchIndex + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const globalTransitionIndex = (0, $cozmU.useMemo)(()=>$ba24a8cc7b954968$var$findTransitionIndex(commentsList), [
        commentsList
    ]);
    const transitionBatchIndex = Math.floor(globalTransitionIndex / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const transitionIndexWithinBatch = globalTransitionIndex % $ba24a8cc7b954968$export$3577ba943a5537ec;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, batches.map((_, index)=>{
        const isTransitionBatch = index === transitionBatchIndex && globalTransitionIndex !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eYRP.CommentBatch), {
            key: `${contentId}-batch-${index}`,
            commentsList: commentsList,
            canRenderBatch: index <= batch,
            batchIndex: index,
            passThroughProps: passThroughProps,
            Component: Component,
            getElementsToBatch: getElementsToBatch,
            onBatchRendered: onBatchRendered,
            transitionIndexWithinBatch: isTransitionBatch ? transitionIndexWithinBatch : undefined
        });
    }));
};
const $ba24a8cc7b954968$export$69f1296a446ecce6 = /*#__PURE__*/ (0, $cozmU.memo)($ba24a8cc7b954968$var$CommentBatchListInner);
module.exports["BATCH_SIZE"] = $ba24a8cc7b954968$export$3577ba943a5537ec;
module.exports["CommentBatchList"] = $ba24a8cc7b954968$export$69f1296a446ecce6;

});

parcelRegister("6eYRP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $lfoFx = parcelRequire("lfoFx");


var $3cu4A = parcelRequire("3cu4A");

const $4d6840eb7d00cd1a$var$spinnerContainerStyles = (0, $buxP3.xcss)({
    margin: 'auto',
    position: 'sticky',
    bottom: '1px'
});
const $4d6840eb7d00cd1a$export$f7f1256703956fe = 100;
const $4d6840eb7d00cd1a$var$CommentBatchInner = ({ passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch, commentsList: commentsList, canRenderBatch: canRenderBatch, batchIndex: batchIndex, onBatchRendered: onBatchRendered, transitionIndexWithinBatch: transitionIndexWithinBatch })=>{
    const [showSpinner, setShowSpinner] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (canRenderBatch) {
            setShowSpinner(true);
            setTimeout(()=>{
                onBatchRendered(batchIndex);
                setShowSpinner(false);
            }, $4d6840eb7d00cd1a$export$f7f1256703956fe);
        }
    }, [
        canRenderBatch,
        batchIndex,
        onBatchRendered
    ]);
    if (!canRenderBatch) return null;
    const batchOffset = batchIndex * (0, $3cu4A.BATCH_SIZE);
    const batchedList = commentsList.slice(batchOffset, batchOffset + (0, $3cu4A.BATCH_SIZE));
    const elements = getElementsToBatch(batchedList, passThroughProps, Component, transitionIndexWithinBatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, elements, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d6840eb7d00cd1a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "comment-batch",
        size: "medium"
    })) : null);
};
const $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe = /*#__PURE__*/ (0, $cozmU.memo)($4d6840eb7d00cd1a$var$CommentBatchInner);
module.exports["CommentBatch"] = $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe;

});

parcelRegister("i8TeS", function(module, exports) {
/* BaseCommentThread.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $4ez2K = parcelRequire("4ez2K");


var $hMaHH = parcelRequire("hMaHH");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $cAdj8 = parcelRequire("cAdj8");


var $fHAwL = parcelRequire("fHAwL");


var $cZRYC = parcelRequire("cZRYC");


var $ibqdE = parcelRequire("ibqdE");

const $74b51dc92462c104$var$styles = {
    threadBoxStyles: "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _kqswh2mm _19bvpxbi _u5f3pxbi _ca0qpxbi _n3tdpxbi _1e0c1txw _2lx21bp4",
    selectedThreadStyles: "_bfhkl4ek",
    commentTypeSeperatorStyle: "_zulp1b66 _x3doia51 _ca0q1ejb _u5f31ejb _n3tdutpp _19bvpxbi",
    commentBodyBoxStyles: "_qtt8glyw _kqswh2mm"
};
const $74b51dc92462c104$var$i18n = (0, $kSwu1.defineMessages)({
    commentTypeSeperatorText: {
        id: "comments-common.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        // COMMENTS-5979: ObjectCommentThread doesn't have timestamp, but it probably should
        id: "comments-common.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread, {timestamp}"
    }
});
const $74b51dc92462c104$var$noop = ()=>{}; // This component renders the parent comment and its replies.
const $74b51dc92462c104$export$a9ce751de1bf208f = ({ commentThreadRef: commentThreadRef, commentComponent: commentComponent, commentRepliesComponent: commentRepliesComponent, parentComment: parentComment, eventEmitter: eventEmitter, pageMode: pageMode, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, canAddComments: canAddComments, handleCommentThreadClick: handleCommentThreadClick, handleCommentThreadMouseDown: onCommentThreadMouseDown, testIdPrefix: testIdPrefix, isEditorExpanded: isEditorExpanded, forceShowRepliesSection: forceShowRepliesSection = false, parentHasAgentSession: parentHasAgentSession = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { currentlySelectedThreadKey: currentlySelectedThreadKey, isCurrentlySelectedThreadOptimisticallyAdded: isCurrentlySelectedThreadOptimisticallyAdded } = (0, $3mVfX.useCommentsPanelState)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef ?? '' : parentComment.id;
    const [isThreadHovered, setIsThreadHovered] = (0, $cozmU.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $cozmU.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $cozmU.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $cozmU.useState)(false);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey || // Special handling to avoid UI flicker when optimistically adding a footer comment.
    // See comments in `next/packages/comments-panel-utils/src/useCommentsPanel.ts` for details.
    parentComment.type === (0, $8i27m.CommentType).GENERAL && !!isCurrentlySelectedThreadOptimisticallyAdded && threadKey === (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID);
    (0, $cozmU.useEffect)(()=>{
        const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply.id === currentlySelectedThreadKey);
        if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
        else setIsThreadPressed(false);
    }, [
        currentlySelectedThreadKey,
        isCurrentSelectedComment,
        parentComment?.replies
    ]);
    const handleCommentThreadMouseDown = (0, $cozmU.useCallback)(()=>{
        onCommentThreadMouseDown?.(); /**
                                   * Limiting executions of this function because updating isThreadPressed
                                   * rerenders every component in this tree. Most notably, a user clicking into
                                   * the reply comment editor will call this function every time (and really any sibling component).
                                   * 1. isThreadPressed is only used as a style variable alongside isCurrentSelectedComment
                                   * 2. if clicking doesn't change threadKey then currentlySelectedThreadKey never changes either
                                   * which are the two variables isCurrentSelectedComment compares. We should only call this function
                                   * if threadKey has changed.
                                   */ 
        if (!isCurrentSelectedComment) setIsThreadPressed(true);
    }, [
        onCommentThreadMouseDown,
        isCurrentSelectedComment
    ]);
    const handleCommentThreadHoverProps = (0, $cozmU.useMemo)(()=>({
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode,
            eventEmitter: eventEmitter
        }), [
        threadKey,
        setIsThreadHovered,
        setHoveredCommentId,
        pageMode,
        eventEmitter
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)((id)=>{
        (0, $cZRYC.handleCommentThreadMouseEnter)({
            ...handleCommentThreadHoverProps,
            id: id
        });
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        (0, $cZRYC.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleFocus = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        setCommentIsFocused(true);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        // Only clear focus if we're not focusing a child element
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    const resolveProperties = parentComment.location?.inlineResolveProperties || parentComment.location?.commentResolveProperties || undefined;
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: resolveProperties
    });
    const timestamp = (0, $6faGq.formatTimestampForAriaLabel)({
        intl: intl,
        dateString: parentComment.createdAtNonLocalized,
        commentStatus: commentStatus,
        resolveProperties: resolveProperties
    });
    const testIdPrefixWithDelimiter = testIdPrefix ? `${testIdPrefix}-` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $74b51dc92462c104$var$styles.commentTypeSeperatorStyle,
        as: "li",
        testId: "comment-section-separator",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        testId: "general-comment-page-icon",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: commentThreadRef,
        id: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        testId: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        xcss: (0, $w6R6I.cx)($74b51dc92462c104$var$styles.threadBoxStyles, (isCurrentSelectedComment || isThreadPressed) && $74b51dc92462c104$var$styles.selectedThreadStyles),
        "data-selected-comment-thread": isCurrentSelectedComment && parentComment.location?.inlineMarkerRef ? parentComment.location.inlineMarkerRef : undefined,
        onClick: handleCommentThreadClick,
        onMouseDown: handleCommentThreadMouseDown,
        onMouseUp: ()=>setIsThreadPressed(false),
        onFocus: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleFocus,
        onBlur: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleBlur,
        onKeyDown: ()=>{},
        tabIndex: 0,
        "aria-label": formatMessage($74b51dc92462c104$var$i18n.threadContentAriaLabelWithName, {
            name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            timestamp: timestamp
        }),
        role: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `${testIdPrefixWithDelimiter}comment-thread-${parentComment.id}-parent`,
        xcss: $74b51dc92462c104$var$styles.commentBodyBoxStyles,
        onMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : ()=>handleMouseEnter(parentComment.id),
        onMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleMouseLeave
    }, commentComponent({
        comment: parentComment,
        pageInfo: pageInfo,
        pageMode: pageMode,
        isUnread: unreadCommentIDSet.has(parentComment.id),
        isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === parentComment.id || commentIsFocused,
        threadKey: threadKey,
        hideBranchingStyle: !parentHasAgentSession && ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? parentComment.replies.length === 0 && !isEditorExpanded : (!parentComment.isOpen || !canAddComments) && parentComment.replies.length === 0),
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered
    })), ((0, $ibqdE.getShouldShowRepliesSection)({
        replies: parentComment.replies,
        isEditorExpanded: isEditorExpanded
    }) || forceShowRepliesSection) && commentRepliesComponent({
        parentComment: parentComment,
        pageInfo: pageInfo,
        hoveredCommentId: hoveredCommentId ?? '',
        pageMode: pageMode,
        parentCommentId: parentComment.id,
        handleMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $74b51dc92462c104$var$noop : handleMouseEnter,
        handleMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $74b51dc92462c104$var$noop : handleMouseLeave,
        canAddComments: canAddComments,
        isEditorExpanded: isEditorExpanded
    })));
};
module.exports["BaseCommentThread"] = $74b51dc92462c104$export$a9ce751de1bf208f;

});

parcelRegister("cZRYC", function(module, exports) {

var $fJCU9 = parcelRequire("fJCU9");


var $cD1qu = parcelRequire("cD1qu");

const $360cac0569dadbce$export$24cbf19a725de615 = ({ id: id, threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(true);
        id && setHoveredCommentId(id);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('sethoveredannotation', threadKey);
        else eventEmitter?.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
const $360cac0569dadbce$export$8ce16d4c9a8b2b8a = ({ threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(false);
        setHoveredCommentId(undefined);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('removehoveredannotation', threadKey);
        else eventEmitter?.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
module.exports["handleCommentThreadMouseEnter"] = $360cac0569dadbce$export$24cbf19a725de615;
module.exports["handleCommentThreadMouseLeave"] = $360cac0569dadbce$export$8ce16d4c9a8b2b8a;

});

parcelRegister("7wP5b", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $189731c52bd04a36$var$createInlineMarkerMatcher = (parentLocation)=>(reply)=>{
        if (!reply) return false;
        const replyLocation = reply.location;
        return parentLocation.inlineMarkerRef === replyLocation.inlineMarkerRef;
    };
const $189731c52bd04a36$export$ea659f9ae26b6c6b = (parentComment, location)=>{
    const { hasNestedComments: legacyHasNestedComments } = (0, $8i27m.useCommentsDataState)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const hasNestedComments = (0, $6mKj3.expValEquals)('cc_comments_new_comments_data_manager', 'isEnabled', true) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const { replyToCommentId: replyToCommentId, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    return (0, $cozmU.useMemo)(()=>{
        if (location === (0, $i6UMJ.LocationValue).FOOTER) {
            if (commentLocation === (0, $i6UMJ.LocationValue).FOOTER) return parentComment.id === replyToCommentId || // Editor management depends on reply nesting configuration:
            // - With nested replies: ObjectCommentNestableReplies handles the Editor
            // - Without nested replies: Open Editor when replyToComment query parameter
            //   matches a reply's ID
            !hasNestedComments && parentComment.replies.some(({ id: id })=>id === replyToCommentId);
            return false;
        }
        const inlineMarkerMatcher = $189731c52bd04a36$var$createInlineMarkerMatcher(parentComment.location);
        const parentReplies = parentComment.replies || [];
        const matchedReplies = parentReplies.filter(inlineMarkerMatcher);
        if (commentLocation === (0, $i6UMJ.LocationValue).PANEL) {
            const isReplyingToParent = replyToCommentId === parentComment.id;
            const isReplyingToChild = matchedReplies.some((reply)=>reply.id === replyToCommentId);
            const canExpandForChildReply = isReplyingToChild && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true);
            return isReplyingToParent || canExpandForChildReply;
        }
        return false;
    }, [
        commentLocation,
        hasNestedComments,
        location,
        parentComment.id,
        parentComment.location,
        parentComment.replies,
        replyToCommentId
    ]);
};
module.exports["useIsEditorExpanded"] = $189731c52bd04a36$export$ea659f9ae26b6c6b;

});

parcelRegister("fy5yb", function(module, exports) {

var $epbW8 = parcelRequire("epbW8");


var $8i27m = parcelRequire("8i27m");

const $747cae967af72a91$export$765c3cc11af57952 = (unresolvedInlineComments)=>Object.fromEntries(unresolvedInlineComments.map((annotationId)=>[
            annotationId,
            {
                id: annotationId,
                annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                state: (0, $epbW8.AnnotationMarkStates).RESOLVED
            }
        ]));
const $747cae967af72a91$var$extractAllComments = (commentsDataMap)=>Object.values(commentsDataMap).flatMap((dataMap)=>Object.values(dataMap));
const $747cae967af72a91$var$excludeDraftComments = (comments)=>comments.filter((comment)=>comment.contentStatus !== 'draft');
const $747cae967af72a91$var$extractUnresolvedCommentIds = (comments)=>comments.filter((comment)=>comment.isOpen).map((comment)=>comment.id);
const $747cae967af72a91$export$8407ff9f3ad87778 = (commentsDataMap, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    return $747cae967af72a91$var$extractUnresolvedCommentIds(allParentComments);
};
const $747cae967af72a91$var$COMMENTS_LOCATIONS = {
    INLINE: 'INLINE',
    FOOTER: 'FOOTER'
};
const $747cae967af72a91$export$e25befbc00a116b = (resolvedComments, commentData)=>{
    if (!resolvedComments?.comments?.nodes) return commentData;
    const resolvedCommentNodes = resolvedComments.comments.nodes.filter((node)=>node !== null);
    const updateComments = (comments, locationType, commentType)=>Object.keys(comments).reduce((acc, key)=>{
            const comment = comments[key];
            const resolvedComment = resolvedCommentNodes.find((resolved)=>locationType === $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE ? resolved.location.inlineMarkerRef === key && resolved.location.type === locationType : resolved.id === key && resolved.location.type === locationType);
            if (resolvedComment && comment.isOpen) return {
                ...acc,
                [key]: {
                    ...resolvedComment,
                    isOpen: false,
                    type: commentType
                }
            };
            else return {
                ...acc,
                [key]: comment
            };
        }, {});
    const updatedInlineComments = updateComments(commentData.inline, $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE, (0, $8i27m.CommentType).INLINE);
    const updatedGeneralComments = updateComments(commentData.general, $747cae967af72a91$var$COMMENTS_LOCATIONS.FOOTER, (0, $8i27m.CommentType).GENERAL);
    return {
        inline: updatedInlineComments,
        general: updatedGeneralComments
    };
};
const $747cae967af72a91$export$4e544898773875e3 = ({ isReply: isReply, threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    if (isReply) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: {
            [threadKey]: commentsDataMap.inline[threadKey]
        },
        [(0, $8i27m.CommentType).GENERAL]: {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$36d96c1319999e05 = ({ threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: commentType === (0, $8i27m.CommentType).INLINE ? {
            [threadKey]: parentComment
        } : {},
        [(0, $8i27m.CommentType).GENERAL]: commentType === (0, $8i27m.CommentType).GENERAL ? {
            [threadKey]: parentComment
        } : {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$485aa15bd11fefca = ({ threadKey: threadKey, commentId: commentId, commentType: commentType, commentsDataMap: commentsDataMap, handleRemovingComments: handleRemovingComments })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const replies = parentComment.replies;
    const deletedReplyComment = replies.find((reply)=>reply.id === commentId);
    if (!deletedReplyComment) return null;
    handleRemovingComments({
        threadKey: threadKey,
        commentId: commentId,
        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
        commentType: commentType
    });
    return deletedReplyComment;
};
module.exports["getResolvedAnnotationState"] = $747cae967af72a91$export$765c3cc11af57952;
module.exports["computeResolvedCommentIds"] = $747cae967af72a91$export$8407ff9f3ad87778;
module.exports["updateResolvedComments"] = $747cae967af72a91$export$e25befbc00a116b;
module.exports["deleteInlineParentComment"] = $747cae967af72a91$export$4e544898773875e3;
module.exports["deleteParentCommentOptimistically"] = $747cae967af72a91$export$36d96c1319999e05;
module.exports["deleteReplyCommentOptimistically"] = $747cae967af72a91$export$485aa15bd11fefca;

});

parcelRegister("g8bbY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $bGjLa = parcelRequire("bGjLa");

const $ed6d952ef1a68788$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $ed6d952ef1a68788$export$4153d6fbc2386422;

});

parcelRegister("hXzKU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("2DNpu"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("2DNpu"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("2DNpu"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c8fhey _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("2DNpu", function(module, exports) {

let $1ec58d175fef2df5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1ec58d175fef2df5$var$load("kT6dz"),
    $1ec58d175fef2df5$var$load("hUbK8"),
    $1ec58d175fef2df5$var$load("6wr18"),
    $1ec58d175fef2df5$var$load("9dRBj"),
    $1ec58d175fef2df5$var$load("932o4"),
    $1ec58d175fef2df5$var$load("lE3Rc"),
    $1ec58d175fef2df5$var$load("29yyZ"),
    $1ec58d175fef2df5$var$load("85fcy"),
    $1ec58d175fef2df5$var$load("8XMho"),
    $1ec58d175fef2df5$var$load("j5RRe"),
    $1ec58d175fef2df5$var$load("e5ukl"),
    $1ec58d175fef2df5$var$load("aUtAe"),
    $1ec58d175fef2df5$var$load("hdjEn"),
    $1ec58d175fef2df5$var$load("dxf7e"),
    $1ec58d175fef2df5$var$load("24IUw"),
    $1ec58d175fef2df5$var$load("4CVPe"),
    $1ec58d175fef2df5$var$load("2J2X1"),
    $1ec58d175fef2df5$var$load("7k0CW"),
    $1ec58d175fef2df5$var$load("35X59"),
    $1ec58d175fef2df5$var$load("ahuWz"),
    $1ec58d175fef2df5$var$load("kqlwS"),
    $1ec58d175fef2df5$var$load("eFxOr"),
    $1ec58d175fef2df5$var$load("hnxOv"),
    $1ec58d175fef2df5$var$load("8pS71"),
    $1ec58d175fef2df5$var$load("dQpR7"),
    $1ec58d175fef2df5$var$load("j1oiH"),
    $1ec58d175fef2df5$var$load("hs6P3"),
    $1ec58d175fef2df5$var$load("kSgPY"),
    $1ec58d175fef2df5$var$load("dxcsb"),
    $1ec58d175fef2df5$var$load("1qlDN"),
    $1ec58d175fef2df5$var$load("1yVM6"),
    $1ec58d175fef2df5$var$load("dZYhM"),
    $1ec58d175fef2df5$var$load("fWgnv"),
    $1ec58d175fef2df5$var$load("9uywJ"),
    $1ec58d175fef2df5$var$load("fkLbQ"),
    $1ec58d175fef2df5$var$load("bMNgp"),
    $1ec58d175fef2df5$var$load("1T8H1"),
    $1ec58d175fef2df5$var$load("fyKFO"),
    $1ec58d175fef2df5$var$load("d9sg7"),
    $1ec58d175fef2df5$var$load("l0N35"),
    $1ec58d175fef2df5$var$load("b2yG5"),
    $1ec58d175fef2df5$var$load("fnmAQ"),
    $1ec58d175fef2df5$var$load("3mbqY"),
    $1ec58d175fef2df5$var$load("hJj0Z"),
    $1ec58d175fef2df5$var$load("7gL7H"),
    $1ec58d175fef2df5$var$load("ffEVr"),
    $1ec58d175fef2df5$var$load("jUHie"),
    $1ec58d175fef2df5$var$load("hLmw0"),
    $1ec58d175fef2df5$var$load("6T1Yh"),
    $1ec58d175fef2df5$var$load("a40Md"),
    $1ec58d175fef2df5$var$load("5e5ry"),
    $1ec58d175fef2df5$var$load("auRBc"),
    $1ec58d175fef2df5$var$load("ehgfN"),
    $1ec58d175fef2df5$var$load("6FgPn"),
    $1ec58d175fef2df5$var$load("cuWsK"),
    $1ec58d175fef2df5$var$load("35yiN"),
    $1ec58d175fef2df5$var$load("Wowvf"),
    $1ec58d175fef2df5$var$load("eRhBr"),
    $1ec58d175fef2df5$var$load("fGW6H"),
    $1ec58d175fef2df5$var$load("7EorR"),
    $1ec58d175fef2df5$var$load("g6v95"),
    $1ec58d175fef2df5$var$load("hhss7"),
    $1ec58d175fef2df5$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("b4BfG", function(module, exports) {

var $hMac6 = parcelRequire("hMac6");


var $cozmU = parcelRequire("cozmU");


var $g8bbY = parcelRequire("g8bbY");


var $koEBx = parcelRequire("koEBx");


var $jMyy4 = parcelRequire("jMyy4");


var $hXzKU = parcelRequire("hXzKU");


var $emtVP = parcelRequire("emtVP");


var $gurMq = parcelRequire("gurMq");


var $4rKYp = parcelRequire("4rKYp");


var $aGjYc = parcelRequire("aGjYc");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

const $a75b2138c8eb75e6$export$b9905c4f8315d0a1 = ({ mode: mode, saveHandler: saveHandler, cancelHandler: cancelHandler, onEditorLoaded: onEditorLoaded, onEditorReady: onEditorReady, onEditorContentChanged: onEditorContentChanged, onEditorContentChangedWithData: onEditorContentChangedWithData, afterActivate: afterActivate, content: content, useNewExperienceAbort: useNewExperienceAbort, expandEditor: expandEditor, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, isOffline: isOffline = false, showAgentMentionFyiNudge: showAgentMentionFyiNudge = true })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: showAgentMentionFyiNudge && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    });
    // Track whether the FYI component has ever been shown, so we only load the
    // chunk on first mention but keep it mounted for the collapse animation.
    const hasShownFyiRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const handleContentChangeWithData = (0, $cozmU.useCallback)((hasChanges, adf)=>{
        onEditorContentChangedWithData?.(hasChanges, adf);
        onAgentMentionContentChange(adf);
    }, [
        onEditorContentChangedWithData,
        onAgentMentionContentChange
    ]);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hMac6.default), {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId,
        __callerPackage__: "comment-simple"
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const operations = (0, $cozmU.useMemo)(()=>data?.content?.nodes?.[0]?.operations ?? [], [
        data
    ]);
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $cozmU.useMemo)(()=>(0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? data?.content?.nodes?.[0]?.space?.operations || [] : [], [
        data
    ]);
    const canAddComment = (0, $cozmU.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'), [
        operations
    ]);
    const canAddAttachment = (0, $cozmU.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'), [
        operations,
        spaceOperations
    ]);
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    // Simulate the unmount function for the other editor
    (0, $cozmU.useEffect)(()=>()=>{
            cancelHandler({
                isEditorAborted: false
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $cozmU.useEffect)(()=>{
        const handleExperienceAbort = ()=>{
            const reason = 'Navigated away from page';
            if (mode === 'edit') experienceTracker.abort({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else if (mode === 'reply') experienceTracker.abort({
                name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else experienceTracker.abort({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
        };
        if (useNewExperienceAbort) window.addEventListener('beforeunload', handleExperienceAbort);
        return ()=>{
            if (useNewExperienceAbort) window.removeEventListener('beforeunload', handleExperienceAbort);
        };
    }, [
        experienceTracker,
        mode,
        useNewExperienceAbort
    ]);
    const handleSave = (0, $cozmU.useCallback)((adf, onSuccess)=>saveHandler({
            adf: adf
        }, onSuccess).then((result)=>{
            if ((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) {
                // `result` is { id: comment.id } returned by the parent saveHandler
                // (ObjectAddCommentEditor or CommentsPanelFooter) after the mutation resolves.
                const commentId = result?.id ?? '';
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, contentId ?? '', commentId, userId ?? undefined);
            }
            return result;
        }).catch((err)=>{
            // There is another handler higher up to re-enable the buttons, throw the error to allow for that
            throw err;
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        saveHandler,
        cloudId,
        contentId,
        userId
    ]);
    const handleCancel = (0, $cozmU.useCallback)((params)=>{
        // handleCancel() is invoked by CommentEditor on its destruction, with
        // `destroy` set to true. In this case, `isEditorAborted` should be
        // false since user didn't explicitly abort commenting. If user did
        // abort, `destroy` will be false, and we should pass `isEditorAborted`
        // as true into cancelHandler().
        const isEditorAborted = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)('page', 'create') ? !params?.destroy : true;
        cancelHandler({
            isEditorAborted: isEditorAborted
        });
    }, [
        cancelHandler
    ]);
    const handleEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        onEditorLoaded();
        onEditorReady?.(editorActions);
    }, [
        onEditorLoaded,
        onEditorReady
    ]);
    const agentMentionFyiNudge = showAgentMentionFyiNudge && (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
        visible: showFyi,
        agent: agent
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, agentMentionFyiNudge, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXzKU.LazyCommentEditorWithoutSpinner), {
        pageId: contentId,
        pageType: contentType,
        appearance: isCommentsPanel ? 'chromeless' : 'comment',
        EditorComponent: isCommentsPanel ? (0, $koEBx.ChromelessEditor) : (0, $g8bbY.CommentEditor),
        commentMode: mode,
        commentType: "page",
        spaceId: spaceId,
        onSaveComment: handleSave,
        content: content,
        onCancelComment: handleCancel,
        onEditorReady: handleEditorReady,
        onContentChange: onEditorContentChanged,
        onContentChangeWithData: handleContentChangeWithData,
        afterActivation: afterActivate,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        shouldWarnOnInternalNavigation: true,
        expandEditor: expandEditor,
        showCancelButton: isCommentsPanel || isFooterComment,
        useNewWarningModal: isCommentsPanel || isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isOffline: isOffline
    }));
};
module.exports["PageCommentEditor"] = $a75b2138c8eb75e6$export$b9905c4f8315d0a1;

});

parcelRegister("hMac6", function(module, exports) {
/**
 * @generated SignedSource<<559b8c3f2a1f2883141ee4463673d17c>>
 * @relayHash 84a9c75863296610fb60639c2398b5f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608
const $e6c37684dc7bdb3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "84a9c75863296610fb60639c2398b5f3",
            "id": "f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608",
            "metadata": {},
            "name": "PageCommentEditorContentOperationsQuery",
            "operationKind": "query",
            "text": "query PageCommentEditorContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}}}"
        }
    };
}();
$e6c37684dc7bdb3d$var$node.hash = "84986896d9e1b1e2bb0707f822adf359";
var $e6c37684dc7bdb3d$export$2e2bcd8739ae039 = $e6c37684dc7bdb3d$var$node;
module.exports["default"] = $e6c37684dc7bdb3d$export$2e2bcd8739ae039;

});

parcelRegister("koEBx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $eJlpI = parcelRequire("eJlpI");

const $6173d76fe85d4dd6$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $eJlpI.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $eJlpI.default)
    });
};
module.exports["ChromelessEditor"] = $6173d76fe85d4dd6$export$5252bd745392dcde;

});

parcelRegister("kKAQX", function(module, exports) {
/**
 * @generated SignedSource<<c5008fda444ba5427db7f5c49b38d99b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $485d7166d746f7d6$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $485d7166d746f7d6$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $485d7166d746f7d6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ContentRepresentation"] = $485d7166d746f7d6$export$f4016897b165b6d5;
module.exports["Platform"] = $485d7166d746f7d6$export$2dffd0b5373a4389;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$export$2512ab5eef87236d = [
    'attachments',
    'blog-posts',
    'change-history',
    'contributors',
    'detailssummary',
    'iframe',
    'include',
    'pagetree',
    'pagetreesearch',
    'profile',
    'profile-picture',
    'recently-updated',
    'viewpdf',
    'viewxls',
    'widget',
    'contentbylabel',
    'popular-labels',
    'tasks-report-macro'
];
const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'blog-posts':
            return (0, $6mKj3.expValEquals)('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
        case 'contentbylabel':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contentbylabel_legacy_macro', 'isEnabled', true);
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'detailssummary':
        case 'profile':
        case 'profile-picture':
            return (0, $6mKj3.expValEquals)('cc_macro_full_ssr_support', 'isEnabled', true);
        case 'iframe':
            return (0, $6mKj3.expValEquals)('cc_rewrite_iframe_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_search_legacy_macro', 'isEnabled', true);
        case 'popular-labels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'viewpdf':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewpdf_macro', 'isEnabled', true);
        case 'viewxls':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewxls_legacy_macro', 'isEnabled', true);
        case 'widget':
            return (0, $6mKj3.expValEquals)('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
        case 'attachments':
            return (0, $6mKj3.expValEquals)('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
        case 'include':
            return (0, $6mKj3.expValEquals)('cc_rewrite_page_include_legacy_macro', 'isEnabled', true);
        case 'tasks-report-macro':
            return (0, $6mKj3.expValEquals)('cc_rewrite_tasks_report_macro', 'isEnabled', true);
        case 'change-history':
            return (0, $6mKj3.expValEquals)('cc_rewrite_change_history_legacy_macro', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>$c9f3102bc65ac225$export$2512ab5eef87236d.includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["MIGRATED_MACRO_EXTENSION_KEYS"] = $c9f3102bc65ac225$export$2512ab5eef87236d;
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<600f249b6150b2ccef97c67793fc3512>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("6hmtW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $cozmU.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $cozmU.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $cozmU.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $cozmU.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $cozmU.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("8BldL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f1df1ad831df9f5a$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $f1df1ad831df9f5a$export$6107f09ca09b8b5f;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("lvJqX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_1reo1wug _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_x5v91ft0",
    confirmation: "_x5v94pcx",
    info: "_x5v9qm1h",
    warning: "_x5v9ervl",
    error: "_x5v9s4qr"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles
            }, children);
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $cEipP.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))));
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            className: t9
        }, t13);
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        onClose: onCloseDialog,
        content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles
            }, children),
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--popup`,
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $cEipP.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))))
    }));
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_syaz1ft0",
    confirmation: "_syaz4pcx",
    info: "_syazqm1h",
    warning: "_syazervl",
    error: "_syazs4qr"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_syaz1kum"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        spacing: spacing
    }));
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("eDWhq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $85mU8 = parcelRequire("85mU8");

const $d70864677eee19d7$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $85mU8.getBrowserBridgeAPI)())=>{
    const refApi = (0, $cozmU.useRef)(apiInstance);
    const refReady = (0, $cozmU.useRef)(false);
    const refMount = (0, $cozmU.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $cozmU.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $cozmU.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $cozmU.useCallback)((command_0, params)=>{
        // devx: provide current `clientId`
        return api.send(command_0, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $cozmU.useCallback)((command_1, params_0, options)=>{
        api.broadcast(command_1, params_0, options);
    }, [
        api
    ]);
    const teardown = (0, $cozmU.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
   * If we have already mounted our handlers once and marked ourselves as ready, then this
   * bridge API client is already capable of receiving & handling commands. On subsequent renders
   * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
   *
   * This will ensure the newest state of every handler is being used, with no stale references
   * in closures, as can often occur with initialise-only-once code in React.
   */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $d70864677eee19d7$export$a74fbbd6fb01001c;

});

parcelRegister("76xix", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $de0bfd2141159d80$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("d8UlV"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $de0bfd2141159d80$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $de0bfd2141159d80$export$7ea4e54699cd5224;

});

parcelRegister("d8UlV", function(module, exports) {

let $9917bc308f190038$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9917bc308f190038$var$load("b7fR4").then(()=>parcelRequire('9r8so'));

});

parcelRegister("apWEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7959bd06e7aba5a6$export$2e2bcd8739ae039);

var $jb2R2 = parcelRequire("jb2R2");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $7959bd06e7aba5a6$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $jb2R2.default)(dateLeft, dateRight) / 7;
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("1C8XP", function(module, exports) {

var $3cQo5 = parcelRequire("3cQo5");

const $087454af48047e63$export$c9407390b0cf740d = (0, $3cQo5.default);
module.exports["ActiveInlineCommentsQuery"] = $087454af48047e63$export$c9407390b0cf740d;

});

parcelRegister("3cQo5", function(module, exports) {
/**
 * @generated SignedSource<<131ed4823645958609337a2481f00b28>>
 * @relayHash 0c90169da883bac60f8fe8cfefab06a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4
const $487b4c2a573008bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0c90169da883bac60f8fe8cfefab06a0",
            "id": "552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4",
            "metadata": {},
            "name": "ActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$487b4c2a573008bb$var$node.hash = "93367b15ee96494c20452626f5b23b5d";
var $487b4c2a573008bb$export$2e2bcd8739ae039 = $487b4c2a573008bb$var$node;
module.exports["default"] = $487b4c2a573008bb$export$2e2bcd8739ae039;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("kuBT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28489413fc4445a7626c716baa7dc401>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeb3ffb0a3d9112d$var$_react = $eeb3ffb0a3d9112d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $eeb3ffb0a3d9112d$var$_baseNew = $eeb3ffb0a3d9112d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $eeb3ffb0a3d9112d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eeb3ffb0a3d9112d$var$ReplyLeftIcon = (props)=>/*#__PURE__*/ $eeb3ffb0a3d9112d$var$_react.default.createElement($eeb3ffb0a3d9112d$var$_baseNew.default, Object.assign({
        name: "ReplyLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.78 2.28 2.56 5.498H7.5a8.5 8.5 0 0 1 8.5 8.5h-1.5a7 7 0 0 0-7-7H2.56l3.22 3.22-1.06 1.06-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5z"/>`
    }, props));
$eeb3ffb0a3d9112d$var$ReplyLeftIcon.displayName = 'ReplyLeftIcon';
var $eeb3ffb0a3d9112d$var$_default = module.exports.default = $eeb3ffb0a3d9112d$var$ReplyLeftIcon;

});

parcelRegister("cJomY", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $284f81bf601d8436$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $284f81bf601d8436$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $hekY6.default)([
            $284f81bf601d8436$var$editedContentStyles.root
        ])
    }, children);
$284f81bf601d8436$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $284f81bf601d8436$export$2e2bcd8739ae039 = $284f81bf601d8436$var$Edited;
module.exports["default"] = $284f81bf601d8436$export$2e2bcd8739ae039;

});

parcelRegister("7P5ob", function(module, exports) {
var $a0476e60d46954e4$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $a0476e60d46954e4$export$5fc610914b028d97;

});

parcelRegister("gYQp3", function(module, exports) {
// create separate utils folder if need to export more utils
const $e7e00ee1b8f0e7bd$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e7e00ee1b8f0e7bd$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e7e00ee1b8f0e7bd$var$extractContent = (data, flatMap)=>{
    if ($e7e00ee1b8f0e7bd$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e7e00ee1b8f0e7bd$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e7e00ee1b8f0e7bd$var$validMarks(data)) flatMap.push(data);
};
const $e7e00ee1b8f0e7bd$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e7e00ee1b8f0e7bd$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e7e00ee1b8f0e7bd$export$4cf5403beffb0fc1;

});

parcelRegister("eIO9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $zzZbq = parcelRequire("zzZbq");


var $jXbsB = parcelRequire("jXbsB");


var $8Yi0A = parcelRequire("8Yi0A");


var $e9Hlq = parcelRequire("e9Hlq");


const $22c6369f6e85adc5$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $22c6369f6e85adc5$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $22c6369f6e85adc5$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$22c6369f6e85adc5$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $22c6369f6e85adc5$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : (0, $e9Hlq.KeyPhraseCategory).AUTO;
};
const $22c6369f6e85adc5$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: (0, $e9Hlq.KeyPhraseCategory).AUTO,
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $22c6369f6e85adc5$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $cozmU.useState)($22c6369f6e85adc5$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $cozmU.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $jXbsB.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $jXbsB.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $iDrrr.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $8Yi0A.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $22c6369f6e85adc5$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                keyPhraseCategory: $22c6369f6e85adc5$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $cozmU.useCallback)(()=>{
        setState($22c6369f6e85adc5$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $cozmU.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $cozmU.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $cozmU.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $cozmU.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["getHighlightRegex"] = $22c6369f6e85adc5$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $22c6369f6e85adc5$export$52e9ff9bfbb65046;

});

parcelRegister("jXbsB", function(module, exports) {
const $3d17a38e3ddac80f$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $3d17a38e3ddac80f$export$39b2bc657daf065 = `
	query ${$3d17a38e3ddac80f$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $3d17a38e3ddac80f$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $3d17a38e3ddac80f$export$39b2bc657daf065;

});

parcelRegister("8Yi0A", function(module, exports) {

var $kJQMD = parcelRequire("kJQMD");

const $cac433bd7344ad2b$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $kJQMD.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
module.exports["onShownAutoDefinitionHighlights"] = $cac433bd7344ad2b$export$42897f8f02baa658;

});

parcelRegister("kJQMD", function(module, exports) {
const $6456db9229e50d9f$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $6456db9229e50d9f$export$f600f3124ea5916b;

});

parcelRegister("e9Hlq", function(module, exports) {
var $83451bfb10f50104$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
module.exports["KeyPhraseCategory"] = $83451bfb10f50104$export$17a511c5c23509af;

});

parcelRegister("8tNXq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $zzZbq = parcelRequire("zzZbq");

const $a273dd7aa35752e1$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $a273dd7aa35752e1$export$e955abb82869dc84;

});

parcelRegister("hsCD1", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $e508769d540061ba$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $e508769d540061ba$export$5b2a28beea8d66c3 = new (0, $34VCg.UFOExperience)(`${$e508769d540061ba$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $e508769d540061ba$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $e508769d540061ba$export$5b2a28beea8d66c3;

});

parcelRegister("lmNXu", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $dOBRD.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("dPlMJ", function(module, exports) {
/* ConnectEosBanner.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7dBf8 = parcelRequire("7dBf8");


var $cXtTj = parcelRequire("cXtTj");


var $lvJqX = parcelRequire("lvJqX");


var $1VhsF = parcelRequire("1VhsF");

var $jtT80 = parcelRequire("jtT80");


var $kSwu1 = parcelRequire("kSwu1");


var $7OuPp = parcelRequire("7OuPp");


var $lEfEl = parcelRequire("lEfEl");

function $3d63ea7a98a3f43b$var$_defineProperty(e, r, t) {
    return (r = $3d63ea7a98a3f43b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d63ea7a98a3f43b$var$_toPropertyKey(t) {
    var i = $3d63ea7a98a3f43b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d63ea7a98a3f43b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $3d63ea7a98a3f43b$export$4f5b90a6ce229aa1 = 'customer-messaging-iframe-banner-dismiss-days';
const $3d63ea7a98a3f43b$export$461103d5504d4d8b = 'connect-eos-banner_dismissed';
const $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS = 'SUCCESS';
const $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS = 'BLOCKED';
const $3d63ea7a98a3f43b$export$9d00c95780551685 = 30;
const $3d63ea7a98a3f43b$export$10cefe68e4bb6b44 = 86400000;
const $3d63ea7a98a3f43b$export$a916575f88d9889f = 'customer-messaging-iframe-banner-enabled';
const $3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED = 'customer-messaging-is-dev-canary';
const $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL = 'https://developer.atlassian.com/cloud/jira/platform/developer-canary-program/';
const $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL = 'https://developer.atlassian.com/platform/forge/changelog/';
const $3d63ea7a98a3f43b$var$DEFAULT_LOCALE = 'en';
const $3d63ea7a98a3f43b$var$defaultIntlCache = (0, $kSwu1.createIntlCache)();
const $3d63ea7a98a3f43b$var$defaultIntl = (0, $kSwu1.createIntl)({
    locale: $3d63ea7a98a3f43b$var$DEFAULT_LOCALE
}, $3d63ea7a98a3f43b$var$defaultIntlCache);
const $3d63ea7a98a3f43b$var$containerStyles = {
    marginBottom: '8px'
};
const $3d63ea7a98a3f43b$var$devCanaryMessageStyles = null;
function $3d63ea7a98a3f43b$export$e6e73547b6ec2430(appKey) {
    return `${appKey}-${$3d63ea7a98a3f43b$export$461103d5504d4d8b}`;
}
class $3d63ea7a98a3f43b$var$ConnectEosBannerComponent extends $cozmU.PureComponent {
    _getDismissDurationMs() {
        const days = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$4f5b90a6ce229aa1, {
            fireExperimentExposure: false
        }).get('value', $3d63ea7a98a3f43b$export$9d00c95780551685);
        return (typeof days === 'number' && days > 0 ? days : $3d63ea7a98a3f43b$export$9d00c95780551685) * $3d63ea7a98a3f43b$export$10cefe68e4bb6b44;
    }
    _isDismissed() {
        if (typeof window === 'undefined') return false;
        const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey);
        const storedItem = (0, $7dBf8.AtlBrowserStorageLocal).getItem(dismissStorageKey);
        if (!storedItem) return false;
        let dismissedAt;
        try {
            const parsedItem = JSON.parse(storedItem);
            dismissedAt = parsedItem.value;
        } catch (e) {
            (0, $7OuPp.logger).warn('Failed to parse Connect EOS banner dismissal', {
                key: dismissStorageKey,
                error: e
            });
            return false;
        }
        if (!dismissedAt) return false;
        const dismissedTimestamp = Number(dismissedAt);
        if (isNaN(dismissedTimestamp)) return false;
        return Date.now() - dismissedTimestamp < this._getDismissDurationMs();
    }
    _shouldShowBanner() {
        // Don't show if the main feature gate is not enabled
        if (!(0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$export$a916575f88d9889f)) return false;
         // Don't show for system apps
        if (this.props.isSystemApp) return false;
         // Don't show if previously dismissed (within configured dismiss duration)
        if (this.state.dismissed) return false;
        return true;
    }
    _isProd() {
        if (typeof window === 'undefined') return false;
        return window.location.hostname.endsWith('.atlassian.net');
    }
    _isSiteAdmin() {
        return this.props.isSiteAdmin ?? false;
    }
    _isDevCanary() {
        return (0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED);
    }
    _getConnectedAppsUrl() {
        const cloudId = this.props.cloudId ?? (typeof document !== 'undefined' ? document.querySelector('meta[name="ajs-cloud-id"]')?.content : undefined) ?? undefined;
        const adminHost = this._isProd() ? 'admin.atlassian.com' : 'admin.stg.atlassian.com';
        if (!cloudId) return undefined;
        return `https://${adminHost}/s/${cloudId}/user-connected-apps/tab/installed`;
    }
    _getAdminMessageBody() {
        const { appName: appName } = this.props;
        const connectedAppsUrl = this._getConnectedAppsUrl();
        const message = appName ? (0, $lEfEl.connectEosBannerMessages).adminMessageWithAppName : (0, $lEfEl.connectEosBannerMessages).adminMessageWithoutAppName;
        const connectedApps = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, connectedAppsUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: connectedAppsUrl
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks));
        const values = appName ? {
            appName: /*#__PURE__*/ $cozmU.createElement("strong", null, appName),
            connectedApps: connectedApps
        } : {
            connectedApps: connectedApps
        };
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: values
        }));
    }
    _getNonAdminMessageBody() {
        const { appName: appName } = this.props;
        const message = appName ? (0, $lEfEl.connectEosBannerMessages).nonAdminMessageWithAppName : (0, $lEfEl.connectEosBannerMessages).nonAdminMessageWithoutAppName;
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: appName ? {
                appName: /*#__PURE__*/ $cozmU.createElement("strong", null, appName)
            } : {}
        }));
    }
    _getDevCanaryMessageBody() {
        if (!this._isDevCanary()) return null;
        const developerCanaryProgram = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        const forgeChangelog = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", {
            className: (0, $hekY6.default)([
                "_19pkze3t"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $lEfEl.connectEosBannerMessages).devCanaryMessage,
            values: {
                developerCanaryProgram: developerCanaryProgram,
                forgeChangelog: forgeChangelog
            }
        }));
    }
    _getDismissAction() {
        return /*#__PURE__*/ $cozmU.createElement((0, $jtT80.default), {
            onClick: this._dismiss,
            key: "dismiss"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $lEfEl.connectEosBannerMessages).dismiss));
    }
    getSectionWarningBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-banner",
            style: $3d63ea7a98a3f43b$var$containerStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, this._isSiteAdmin() ? this._getAdminMessageBody() : this._getNonAdminMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    getInlineBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-v2-banner"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: (this.props.intl ?? $3d63ea7a98a3f43b$var$defaultIntl).formatMessage((0, $lEfEl.connectEosBannerMessages).inlineSecondaryText)
        }, this._isSiteAdmin() ? this._getAdminMessageBody() : this._getNonAdminMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    render() {
        if (!this._shouldShowBanner()) return null;
        const banner = this.props.moduleType === 'webPanels' ? this.getInlineBanner() : this.getSectionWarningBanner();
        if (!this.props.intl) return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.RawIntlProvider), {
            value: $3d63ea7a98a3f43b$var$defaultIntl
        }, banner);
        return banner;
    }
    constructor(props){
        super(props);
        $3d63ea7a98a3f43b$var$_defineProperty(this, "_dismiss", ()=>{
            const dismissedAt = Date.now();
            const storedItem = JSON.stringify({
                value: dismissedAt
            });
            const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey); // @browser-storage setter
            (0, $7dBf8.AtlBrowserStorageLocal).setItem(dismissStorageKey, storedItem).then((result)=>{
                if (result?.status && result.status !== $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS && result.status !== $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS) (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    result: result
                });
            }).catch((error)=>{
                (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    error: error
                });
            });
            this.setState({
                dismissed: true
            });
        });
        this.state = {
            dismissed: this._isDismissed()
        };
    }
}
$3d63ea7a98a3f43b$var$_defineProperty($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, "defaultProps", {
    isSystemApp: false,
    moduleType: ''
});
const $3d63ea7a98a3f43b$export$70b82b13309d5477 = (0, $kSwu1.injectIntl)($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, {
    enforceContext: false
});
module.exports["ConnectEosBanner"] = $3d63ea7a98a3f43b$export$70b82b13309d5477;

});

parcelRegister("lEfEl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e33f058366d031a5$export$db71c19e7db05343 = (0, $kSwu1.defineMessages)({
    adminMessageWithAppName: {
        id: "connect-module-core.eos.adminMessageWithAppName",
        defaultMessage: "The {appName} app is running on a platform that'll be unsupported after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    adminMessageWithoutAppName: {
        id: "connect-module-core.eos.adminMessageWithoutAppName",
        defaultMessage: "This app is running on a platform that'll be unsupported after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    nonAdminMessageWithAppName: {
        id: "connect-module-core.eos.nonAdminMessageWithAppName",
        defaultMessage: "The {appName} app is running on a platform that'll be unsupported after December 2026. To explore your options, contact your site admin."
    },
    nonAdminMessageWithoutAppName: {
        id: "connect-module-core.eos.nonAdminMessageWithoutAppName",
        defaultMessage: "This app is running on a platform that'll be unsupported after December 2026. To explore your options, contact your site admin."
    },
    devCanaryMessage: {
        id: "connect-module-core.eos.devCanaryMessage",
        defaultMessage: "You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>."
    },
    dismiss: {
        id: "connect-module-core.eos.dismiss",
        defaultMessage: "Dismiss"
    },
    inlineSecondaryText: {
        id: "connect-module-core.eos.inlineSecondaryText",
        defaultMessage: "This app might stop working soon"
    }
});
module.exports["connectEosBannerMessages"] = $e33f058366d031a5$export$db71c19e7db05343;

});

parcelRegister("jAI8J", function(module, exports) {
/**
 * Set of system app addon keys.
 * These are special built-in applications that are part of the system.
 */ const $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS = new Set([
    'jira-slack-integration',
    'com.atlassian.servicedesk.embedded',
    'com.atlassian.servicedesk.embedded.moderate',
    'stspg-jira-ops',
    'com.atlassian.jira.spreadsheets',
    'atlassian-outlook-integration',
    'com.codebarrel.addons.automation',
    'com.codebarrel.addons.automation.moderate',
    'opsgenie-jira-adapter',
    'opsgenie-jira-adapter.moderate',
    'halp.com',
    'halp.moderate.com',
    'msteams-jira',
    'com.atlassian.atlas.jira',
    'cello',
    'msteams-confluence',
    'opsgenie-incident-timeline-lab',
    'com.addonengine.analytics'
]);
function $252ad196ad9bae6b$export$4d755424ce1abae9(addonKey) {
    return $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS.has(addonKey);
}
module.exports["isSystemApp"] = $252ad196ad9bae6b$export$4d755424ce1abae9;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");


var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");


var $kkFbH = parcelRequire("kkFbH");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $hekY6.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $cozmU.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $cozmU.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $hekY6.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("5YpFT"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("5YpFT"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("5YpFT", function(module, exports) {

let $459678d039ea1454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $459678d039ea1454$var$load("cuWsK"),
    $459678d039ea1454$var$load("35yiN"),
    $459678d039ea1454$var$load("6wr18"),
    $459678d039ea1454$var$load("jYRaq"),
    $459678d039ea1454$var$load("7G12e"),
    $459678d039ea1454$var$load("io0qR"),
    $459678d039ea1454$var$load("ffEVr"),
    $459678d039ea1454$var$load("Wowvf"),
    $459678d039ea1454$var$load("eRhBr"),
    $459678d039ea1454$var$load("7EorR"),
    $459678d039ea1454$var$load("hhss7"),
    $459678d039ea1454$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("14nTY"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("14nTY"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("14nTY", function(module, exports) {

let $0c78b49230bbeca5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0c78b49230bbeca5$var$load("Hl6mt"),
    $0c78b49230bbeca5$var$load("79Tk4"),
    $0c78b49230bbeca5$var$load("fGW6H"),
    $0c78b49230bbeca5$var$load("jXx9i"),
    $0c78b49230bbeca5$var$load("953Uz"),
    $0c78b49230bbeca5$var$load("hhss7"),
    $0c78b49230bbeca5$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("hHZWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("eV0v4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});


//# sourceMappingURL=ObjectCommentContainer.b6c539f1.js.map
